const API_PATH = "/cockpit/api";
const DMS_API_PATH = "/dms/api";
const INCIDENT_API_PATH = "/incidents/api";
const FORM_BUILDER_PATH = "/forms/api";
const ESG_DATA_SERVICE_PATH = '/esg-datasets/api';
const ADMIN_TEMPLATE_SERVICE_PATH = '/admin-templates/api';
const PARTNER_SERVICE_PATH = '/partner';
const KPI_SERVICE_PATH = '/kpi-service/api';
const GHG_EMISSION_PATH = '/ghg-emission/api';
const MATERIALITY_SERVICE_PATH = '/materiality/api';
const REPORT_SERVICE_PATH = '/report';
const COPILOT_PATH = '/copilot';
const COCKPIT_ALCHEMY_PATH = '/cockpit-alchemy/api';
const SHARED_PATH = "/shared";

export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
//export const SUPER_ADMIN_TXT = "SUPER_ADMIN";
export const SUPPLIER_ADMIN_TXT = "SUPPLIER_ADMIN";
export const REPORT_AI_BASE_URL = process.env.REACT_APP_REPORT_AI_SERVICE_URL;
export const SOCKET_BASE_URL = process.env.REACT_APP_SOCKET_API_BASE_URL;
export const REPORTING_BASE_URL = process.env.REACT_APP_REPORT_SERVICE_BASE_URL;
export const ESRS_REPORT_TRANSLATE = process.env.REACT_APP_DEEPL_API_URL;

const API_ROUTES = {
  LOGIN: {
    LOGINAPI: API_PATH + "/general/user/login",
    AUTHORITYAPI: API_PATH + "/user/authority",
    PROFILECOMPLETE: API_PATH + "/companies/",
  },
  LOGOUT: {
    LOGOUTAPI: API_PATH + "/user/logout",
  },
  COMPANY: {
    COMPANYCREATEAPI: API_PATH + "/admin/company-invitations",
    COMPANYLISTAPI:
      API_PATH +
      "/companies?pageNumber=<pageNumber>&pageSize=<pageSize>&key=<key>&sort=<sort>",
    COMPANYSUBSCRIPTIONSAPI: API_PATH + "/companies/<companyId>/subscriptions?regulationType=<regulationType>",
    COMPANYASSOCIATIONS: API_PATH + "/companies/<companyId>/connections?pageNumber=<pageNumber>&pageSize=<pageSize>",
    COMPANYCONTEXTREGULATION: API_PATH + "/context/<encodedUrlParam>/regulations",
    SUPPLIERSCOUNT: API_PATH + "/suppliers/onboard-status-report",
    SUPPLIERSCOUNTBYREGULATION: API_PATH + "/companies/<companyId>/regulations/<regulationId>/risk-category-count/<date>",
    SUPPLIER_STATUS_COUNTRY_REPORT: API_PATH + "/companies/<companyId>/regulations/<regulationId>/suppliers/dashboard/<period>/country",
    SUPPLIER_ACCESSIBLE_REGULATIONS: API_PATH + "/regulations/supplier-accessible-regulations",
    GET_ENTERPRISE_STRUCTURE: API_PATH + "/admin/company/business/unit/parent?showAll=<showAll>",
    ADD_ENTERPRISE: API_PATH + "/admin/company/business/unit",
    GET_ENTERPRISE: API_PATH + "/admin/company/business/unit?businessUnitId=<businessUnitId>",
    GET_ENTERPRISE_CHILDREN: API_PATH + "/admin/company/business/unit/children?businessUnitId=<businessUnitId>",
    UPDATE_ENTERPRISE: API_PATH + "/admin/company/business/unit",
    DELETE_ENTERPRISE: API_PATH + "/admin/company/business/unit?businessUnitId=<businessUnitId>",
    REORDER_ENTERPRISE: API_PATH + "/admin/company/business/unit/<unitId>",
    GET_ENTERPRISE_TYPES: API_PATH + "/admin/company/business-unit/types",
    GET_ENTERPRISES_FOR_TYPE: API_PATH + "/admin/company/business-units/<buType>",
    GET_ENTERPRISES_BY_LEVEL: API_PATH + "/admin/company/business-units/level/<level>",
    GET_INDUSTRIES: API_PATH + "/companies/industries",
    GET_METRIC_QN: API_PATH + "/standard/<standardId>/metric/answer/<period>?pageSize=<pageSize>&pageNumber=<pageNumber>",
    POST_METRIC_ANS: API_PATH + "/metric/answer/<period>/bulk",
    DELETE_METRIC_ANS: API_PATH + "/metric/answer/<answerId>",
    GET_FILTERED_METRIC_QUESTIONS: API_PATH + "/standard/<standardId>/metric/<categoryType>/answer/<period>?topicId=<topicId>&excludePeriodic=true",
    UPDATE_METRIC_QN_STATUS: API_PATH + "/metric/question/<questionId>/status/<status>",
    GET_ENTERPRISE_STRUCTURE_MIN: API_PATH + "/admin/company/business/unit/parent/minimal",
    DOWNLOAD_BUSINESS_UNIT_TEMPLATE: API_PATH + "/admin/company/business-unit/export/template",
    IMPORT_BUSINESS_UNIT_DATA: API_PATH + "/admin/company/business-unit/import",
    QUALITATIVE_METRIC_ANSWER_SEARCH:
      API_PATH + "/standard/<standardId>/metric/<metricId>/answer/<period>/search",
    QUALITATIVE_DISCLOSURE_ANSWER_SEARCH:
      API_PATH + "/disclosure/answer/<period>/search",
    DELETE_METRIC_ANS_BULK: API_PATH + "/metric/answers",
  },
  UTILS: {
    PHONECODESAPI: API_PATH + "/phone-codes",
    COUNTRYLISTAPI: API_PATH + "/countries",
    STATELISTAPI: API_PATH + "/states",
    CURRENCYLISTAPI: API_PATH + "/currencies"
  },
  SETPWD: {
    INVITATIONVERIFY: API_PATH + "/public/company-invitations",
    SETNEWPASSWORD: API_PATH + "/public/company-invitations/register",
  },
  INVITATIONS: {
    GETLIST: API_PATH + "/company-invitations",
    RESENDINVITATION:
      API_PATH + "/company-invitations/<invitationId>/status/<status>",
    UPDATEINVITATION: API_PATH + "/company-invitations/<invitationId>",
    PENDINGINVITATIONS: API_PATH + "/company-invitations?page=<pageNumber>&size=<pageSize>&pending=true",
    GETINVITATIONBY_ID: API_PATH + "/company-invitations/<invitationId>",
  },
  COMPANYONBOARD: {
    ONBOARD: API_PATH + "/company-invitations/",
  },
  SUPPLIERDETAILSONBOARD: {
    SUPPLYMATERIALSLIST: API_PATH + "/companies/",
    ONBOARD: API_PATH + "/suppliers/",
  },
  SUPPLIER: {
    SUPPLIERCREATEAPI: API_PATH + "/company-invitations",
    SUPPLIERTYPESAPI: API_PATH + "/companies/<companyId>/supplier-types?key",
    COMPANYEMAILEXISTCHECKAPI:
      API_PATH + "/companies/search/email?email=<emailId>",
    SUPPLIERLISTAPI:
      API_PATH +
      "/companies/<companyId>/suppliers?pageNumber=<pageNumber>&pageSize=<pageSize>&key=<key>&sort=<sort>&invitation_status=<invitation_status>&email=<email>",
    COMPANYCONNECTIONSAPI:
      API_PATH +
      "/companies/<companyId>/connections?pageNumber=<pageNumber>&pageSize=<pageSize>&key=<key>&sort=<sort>",
    ALLSUPPLIERSLISTAPI:
      API_PATH +
      "/companies/<companyId>/suppliers",
  },
  RISKRULE: {
    GETRULETYPECONFIGAPI:
      API_PATH + "/context/<encodedUrlParam>/risk-rules/<ruleId>/rule-configs",
    GETREGULATIONDETAILSAPI:
      API_PATH + "/context/<encodedUrlParam>/risk-rules/primary_rule",
    UPDATERISKCONFIGAPI:
      API_PATH + "/context/<encodedUrlParam>/risk-rules/<ruleId>/rule-configs",
  },
  RISKCONFIGURATION: {
    CREATEREGULATION: API_PATH + "/admin/regulations",
    UPDATEREGULATION: API_PATH + "/admin/regulations/<regulationId>",
    GETREGULATIONS: API_PATH + "/admin/regulations?regulationType=<regulationType>",
    GETREGULATIONDETAILS: API_PATH + "/admin/regulations/<regulationId>?type=<type>",
    ADDRISKPARAMATER: API_PATH + "/admin/regulations/<regulationId>/param",
    GETRISKDETAILS:
      API_PATH + "/admin/regulations/<regulationId>/param/<riskId>?type=<type>",
    EDITRISKPARAMETER:
      API_PATH + "/admin/regulations/<regulationId>/param/<riskId>",
    DELETERISKPARAMETER:
      API_PATH + "/admin/regulations/<regulationId>/param/<riskId>",
    GETREGULATIONSBYSTATUS: API_PATH + "/admin/regulations?status=<status>",
    PUBLISHREGULATION: API_PATH + "/admin/regulations/<regulationId>/status/published",
    UNLINKDATASOURCE: API_PATH + "/admin/regulations/<regulationId>/param/<riskId>/data-sources?paramType=<paramType>",
  },
  PROFILE: {
    PROFILEDATA: API_PATH + "/context/<encodedUrlParam>/risk-profile",
    RISKDATA: API_PATH + "/context/",
    SUPPLIERRISKSCORE: API_PATH + "/context/<encodedUrlParam>/suppliers/<supplierId>/data-points/<date>/snapshot",
    PROFILESTATUS: API_PATH + "/context/<encodedUrlParam>/profile-status",
  },
  RISKINPUT: {
    SUPPLIERLIST: API_PATH + "/companies/<companyId>/suppliers",
    SUPPLIERDATA:
      API_PATH +
      "/context/<encodedUrlParam>/suppliers/<supplierId>/risk-params/<period>?type=<type>",
    SAVEDATAPOINT:
      API_PATH +
      "/context/<encodedUrlParam>/suppliers/<supplierId>/data-points/<period>/bulk-update",
    COMPANYDATA:
      API_PATH +
      "/company/<companyId>/configuration/<regulationId>/risk-params/result-data/<period>?type=<type>",
    SAVECOMPANYDATAPOINT: API_PATH +
      "/company/<companyId>/configuration/<regulationId>/data-points/<period>/bulk-update",
  },
  DATAPOINTSSUPPLIER: {
    ALLSUPPLIERLIST:
      API_PATH +
      "/context/<encodedUrlParam>/data-points/<period>?pageNumber=<pageNumber>&pageSize=<pageSize>&key=<key>&sort=<sort>&type=<type>",
  },
  SUPPLYMATERIAL: {
    LIST:
      API_PATH +
      "/companies/<companyId>/supply-materials?pageNumber=<pageNumber>&pageSize=<pageSize>&key=<key>&activeOnly=<activeOnly>",
    SUBMIT: API_PATH + "/companies/<companyId>/supply-materials/<id>",
  },
  SUPPLIERTYPE: {
    LIST:
      API_PATH +
      "/companies/<companyId>/supplier-types?pageNumber=<pageNumber>&pageSize=<pageSize>&key=<key>&activeOnly=<activeOnly>",
    SUBMIT: API_PATH + "/companies/<companyId>/supplier-types",
  },
  COUNTRYSCORE: {
    LIST:
      API_PATH +
      "/context/<encodedUrlParam>/country-scores?pageNumber=<pageNumber>&pageSize=<pageSize>&key=<key>",
    SUBMIT: API_PATH + "/context/<encodedUrlParam>/country-scores",
    DELETE: API_PATH + "/context/<encodedUrlParam>/country-scores/<id>",
  },
  SUPERADMINSUBSCRIPTION: {
    LIST:
      API_PATH +
      "/super-admin/subscription-plans?pageNumber=<pageNumber>&pageSize=<pageSize>&key=<key>",
    REGULATIONS: API_PATH + "/admin/regulations?status=PUBLISHED",
    SUBMIT: API_PATH + "/super-admin/subscription-plans",
  },
  ASSIGNSUBSCRIPTION: {
    COMPANYLISTAPI: API_PATH + "/companies?pageNumber=0&pageSize=10&key=<key>",
    SUBMIT: API_PATH + "/subscription-plans/<planId>/subscribe",
    PLANS: API_PATH + "/super-admin/subscription-plans",
  },
  DMS: {
    CREATEFOLDER: DMS_API_PATH + "/createInternalFolder",
    DELETEFOLDER: DMS_API_PATH + "/deleteInternalFolder",
    GETROOTFOLDERS: DMS_API_PATH + "/documents",
    GETSUBFOLDERS: DMS_API_PATH + "/fetchInternalFolders",
    GETFOLDERCONTENT: DMS_API_PATH + "/documents?containerId=<containerId>",
    DELETEDOCUMENT: DMS_API_PATH + "/documents/<documentId>",
    CREATEDOCUMENT: DMS_API_PATH + "/documents",
    RENAMEDOCUMENT: DMS_API_PATH + "/documents/<documentId>/rename?documentName=<documentName>",
    REGULATIONDOC:
      API_PATH + "/regulations/<regId>/document-types?typeId=<typeId>",
    CREATEREGULATIONDOC: API_PATH + "/regulations/<regId>/document-types",
    DELETEREGULATIONDOC:
      API_PATH + "/regulations/<regId>/document-types/<docId>",
    UPDATEREGULATIONDOC:
      API_PATH + "/regulations/<regId>/document-types/<docId>",
    GETDOCUMENTSHAREDWITHUSER: DMS_API_PATH + "/documents?containerId=<containerId>&sharedWithId=<sharedWithId>",
    GETDOCUMENTSSHAREDBYCOMPANY: DMS_API_PATH + "/documents/shared/regulations/<regId>?sharedById=<sharedById>",
    GETFOLDERCONTENTBYCOMPANY: DMS_API_PATH + "/documents/shared/regulations/<regId>?sharedById=<sharedById>&containerId=<containerId>",
  },
  FORMS: {
    LISTFORMS:
      API_PATH +
      "/assessment-forms?pageNumber=<pageNumber>&pageSize=<pageSize>&key=<key>&regulationId=<regulationId>&selfAssessment=<selfAssessment>&sort=<sort>",
    SHAREFORMS: API_PATH + "/assessment-forms/share",
    LISTFORMSFORSHARING:
      API_PATH +
      "/assessment-forms?status=<status>&regulationId=<regulationId>&selfAssessment=<selfAssessment>",
    LISTFORMSFORSUBMISSION:
      API_PATH +
      "/suppliers/<supplierId>/assessment-forms?companyId=<companyId>&regulationId=<regulationId>&pageNumber=<pageNumber>&pageSize=<pageSize>&sort=<sort>&key=<key>",
    FORMSUBMISSIONTOKEN: API_PATH + "/assessment-forms/<formId>/access-token",
    PUBLISHFORMS: FORM_BUILDER_PATH + "/forms/<formId>/status/publish",
    LISTSUBMITTEDFORMS:
      API_PATH +
      "/assessment-forms/<formId>/form-data?pageSize=<pageSize>&pageNumber=<pageNumber>&key=<key>",
    LISTSUBMITTEDFORMSSUPPLIER:
      API_PATH +
      "/assessment-forms/<formId>/form-data?token=<token>&pageSize=<pageSize>&pageNumber=<pageNumber>&key=<key>",
    LISTFORMSSTATUSSUPPLIER:
      API_PATH +
      "/context/<encodedUrlParam>/assessment-forms/snapshots",
    LISTALLFORMSFORSUBMISSION:
      API_PATH +
      "/suppliers/<supplierId>/assessment-forms?regulationId=<regulationId>&pageSize=<pageSize>&pageNumber=<pageNumber>&key=<key>",
    GETFILEUPLOADFIELDS:
      API_PATH +
      "/assessment-forms/<formId>/file-upload-fields",
    UPDATEFILEFIELDTODOC:
      API_PATH +
      "/assessment-forms/<formId>/file-upload-fields/<fieldId>/link-to-folder?docTypeId=<docTypeId>",
    GETLANGUAGES: FORM_BUILDER_PATH + "/languages",
    CREATEFORM: API_PATH + "/assessment-forms",
    LIST_OPEN_FORM_SUBMISSIONS_BY_SUPPLIER:
      API_PATH +
      "/assessment-forms/open-submissions?supplierId=<supplierId>&companyId=<companyId>&regulationId=<regulationId>&pageNumber=<pageNumber>&pageSize=<pageSize>&sort=<sort>",
    GET_SHARES_FOR_FORM: API_PATH + "/assessment-forms/<formId>/shares",
    SHARE_SELF_ASSESSMENT_FORM: API_PATH + "/assessment-forms/self-assessment/share",
    LIST_SUBMITTED_FORMS_V2: API_PATH +
      "/assessment-forms/<formId>/form-data/v2?pageSize=<pageSize>&pageNumber=<pageNumber>&key=<key>&period=<period>&sort=<sort>&selfAssessment=<selfAssessment>&supplierId=<supplierId>&branchId=<branchId>&companyId=<companyId>",
    GET_SUBMITTED_FORMS_COUNT: API_PATH + "/assessment-forms/<formId>/form-data/status-count?&period=<period>",
    GET_ASSESSMENT_FORM: API_PATH + "/assessment-forms/<formId>",
    REMIND_FORM_SUBMISSION: API_PATH + "/remind/assessment-forms",
    GET_ALL: FORM_BUILDER_PATH + '/forms?pageNumber=<pageNumber>&pageSize=<pageSize>&key=<key>&regulationId=<regulationId>&selfAssessment=<selfAssessment>&sort=<sort>&fetchFieldSectionCounts=<fetchFieldSectionCounts>&withLogo=<withLogo>&frequency=<frequency>&type=<type>',
    CREATE: FORM_BUILDER_PATH + '/forms',
    CREATE_WITH_LOGO: FORM_BUILDER_PATH + '/forms/with-logo/<formId>',
    GET_LOGO: BASE_URL + FORM_BUILDER_PATH + '/forms/<formId>/logo/<id>/download',
    UPDATE: FORM_BUILDER_PATH + '/forms/<formId>',
    DELETE: FORM_BUILDER_PATH + '/forms/<formId>',
    UPDATE_DATA_APPROVAL: FORM_BUILDER_PATH + '/forms/<formId>/data-approval/<status>',
  },
  LINKDATASOURCE: {
    LISTDATASOURCEBYREGULATION:
      API_PATH +
      "/admin/regulations/<regulationId>/data-sources?configType=<configType>&parentId=<parentId>&quantitative=<quantitative>",
    SAVEDATASOURCEBYREGULATION:
      API_PATH +
      "/admin/regulations/<regulationId>/param/<paramId>/data-sources/<dsId>?paramType=<paramType>"
  },
  REPORT: {
    DOWNLOAD: API_PATH + "/report/download/<regId>",
    CREATE_REPORT: "/report",
    UPDATE_REPORT: "/report/<reportId>",
    GET_REPORT: "/report/<reportId>",
    LIST_REPORTS: "/report/all?pageSize=<pageSize>&pageNumber=<pageNumber>&regulationId=<regulationId>&companyId=<companyId>&status=<status>",
    GENERATE_PDF: API_PATH + "/report/<reportId>/generate-pdf",
    REORDER_PAGE: API_PATH + "/report/<reportId>/page/<pageId>",
    REPORT_JOB_POLL: "/report/generation/job",
    UPDATE_REPORT_CONTENT: "/gri/report/update-content",
    UPDATE_REPORT_STATUS: "/report/<id>/status/<status>",
    GET_ESG_OVERVIEW_DATA: API_PATH + "/report/esg-overview/standard/<standardId>/section/<sectionType>?periodStart=<periodStart>&periodEnd=<periodEnd>&buIds=<buIds>",
    UPDATE_REPORT_JOB_STATUS: "/report/generation/job/<id>/status/<status>",
    FINALIZE: "/report/<id>/finalize",
    UPLOAD_IMAGE: "/reports/images",
    LIST_IMAGES: "/reports/images?key=<key>",
    GET_IMAGE: REPORTING_BASE_URL + "/public/reports/images/<ref>",
    GET_ESG_HIGHLIGHTS_METRICS: API_PATH + "/report/esg-highlights/standard/<standardId>/period/<period>",
    GET_TEMPLATE: API_PATH + "/admin/report/studio/template?page=<pageId>&type=<type>&standardId=<standardId>&period=<period>",
    CAPTURE_REPORT: API_PATH + "/admin/report/studio/data",
    LIST_GROUPED_STUDIO_REPORTS: API_PATH + "/admin/report/studio/group/data?type=<type>&page=<pageNumber>&size=<pageSize>&sort=<sort>",
    GET_REPORT_TEMPLATE_DATA: API_PATH + "/admin/report/studio/data?page=<pageId>&type=<type>&standardId=<standardId>&period=<period>&title=<title>",
    GET_ESG_HIGHLIGHTS_DATA: API_PATH + "/report/esg/highlights/<standardId>/period/<period>?periodStart=<periodStart>&periodEnd=<periodEnd>&buIds=<buIds>",
    DELETE_IMAGE: "/reports/images/<id>",
    GET_INBOUND_PROGRESS: API_PATH + "/admin/report/data/inbound/progress/<standardId>/period/<period>?recentChangeInfo=<recentChangeInfo>&periodStart=<periodStart>&periodEnd=<periodEnd>&buIds=<buIds>",
    GET_DATA_COLLECTION_PROGRESS: API_PATH + "/admin/data/collection/progress/<standardId>/period/<period>?periodStart=<periodStart>&periodEnd=<periodEnd>",
    CREATE_CODRAFT_JOB: "/report/<id>/codraft/job",
    GET_SETTINGS: "/report/settings",
    SAVE_SETTINGS: "/report/settings",
    UPDATE_REPORT_PAGE: "/report/<reportId>/page/<pageId>",
    CREATE_REPORT_SECTION: "/report/<reportId>/section",
    UPDATE_REPORT_SECTION: "/report/<reportId>/section/<sectionId>",
    DELETE_REPORT_SECTION: "/report/<reportId>/section/<sectionId>",
    CREATE_REPORT_PAGE: "/report/<reportId>/section/<sectionId>/page",
    DELETE_REPORT_PAGE: "/report/<reportId>/section/<sectionId>/page/<pageId>",
  },
  DASHBOARD: {
    COMPANYDASHBOARD: API_PATH + "/companies/<companyId>/regulations/<regulationId>/data-points/<date>/snapshot",
    HIGHRISKSUPPLIER: API_PATH + "/context/<encodedUrlParam>/supplier-risk-scores/<date>?pageNumber=<pageNumber>&pageSize=<pageSize>&sort=<sort>",
    TOPCOUNTRYRISK: API_PATH + "/companies/<companyId>/regulations/<regulationId>/supplier-country-high-risk/<date>",
    LISTALERTS: API_PATH + "/alerts?pageSize=<pageSize>&pageNumber=<pageNumber>&regulationCode=<regulationCode>&sort=<sort>,<sortOrder>",
    CONVERTALERTTOTASK: API_PATH + "/alerts/<alertId>/convert-to-task",
    GETUSERS: API_PATH + "/users?pageSize=<pageSize>&pageNumber=<pageNumber>&key=<key>",
    LISTSUPPLIERALERTS: API_PATH + "/context/<encodedUrlParam>/alerts?pageSize=<pageSize>&pageNumber=<pageNumber>&regulationCode=<regulationCode>&sort=<sort>,<sortOrder>",
    LISTTASKS: API_PATH + "/tasks?pageSize=<pageSize>&pageNumber=<pageNumber>&regulationCode=<regulationCode>&companyId=<companyId>&assignedToMe=<assignedToMe>&createdByMe=<createdByMe>&key=<key>&sort=<sort>&status=<status>&priority=<priority>&assignee_id=<assignee_id>&owner_id=<owner_id>",
    COMPANIES_WITH_HIGH_RISK: API_PATH + "/suppliers/<supplierId>/regulations/<regulationCode>/companies-with-high-risks/<period>",
    FORM_SUBMISSION_EXPIRY: API_PATH + "/assessment-forms/submission-expiry?&regulationId=<regulationId>&pageSize=<pageSize>&pageNumber=<pageNumber>",
    COMPANYSUPPLIERSRISK: API_PATH + "/companies/<companyId>/regulations/<regulationId>/company-supplier-risk-results/<date>/snapshot",
    COMPANYRISK: API_PATH + "/company/<companyId>/configuration/<configuration>/risk-results/<date>/snapshot",
    ENERGYPRODUCED: API_PATH + "/admin/dashboard/graph/energy/produced/period/<period>?standardId=<standardId>",
    ENERGYCONSUMPTIONWITHIN: API_PATH + "/admin/dashboard/graph/energy/consumption/within/period/<period>?standardId=<standardId>",
    AVGENERGYINTENSITYOREMILLED: API_PATH + "/admin/dashboard/graph/energy/ore-milled/intensity/period/<period>?standardId=<standardId>",
    ENERGYCONSUMPTIONOUTSIDE: API_PATH + "/admin/dashboard/graph/energy/consumption/outside/period/<period>?standardId=<standardId>",
    ENERGYINTENSITYBYMETAL: API_PATH + "/admin/dashboard/graph/energy/metal-produced/intensity/period/<period>?standardId=<standardId>",
    GET_TASK_AND_ALERT_COUNT: API_PATH + "/company/count/task/alert?regulationId=<regulationId>",
    WORKFORCETYPE: API_PATH + "/admin/dashboard/graph/workforce/type/period/<period>?standardId=<standardId>",
    DIVERSITYEMPLOYEES: API_PATH + "/admin/dashboard/graph/employee/diversity/period/<period>?standardId=<standardId>",
    NEWHIREDEMPLOYEES: API_PATH + "/admin/dashboard/graph/new/employee/hires/period/<period>?standardId=<standardId>",
    ECONOMICVALUEDISTRIBUTED: API_PATH + "/admin/dashboard/graph/economic/value/distributed/period/<period>?standardId=<standardId>",
    ECONOMICVALUEBYLOCATION: API_PATH + "/admin/dashboard/graph/economic/value/generated/period/<period>?standardId=<standardId>",
    WASTEGENERATEDINORG: API_PATH + "/admin/dashboard/graph/waste/generated/period/<period>?standardId=<standardId>",
    WASTEDISPOSEDINORG: API_PATH + "/admin/dashboard/graph/waste/disposal/period/<period>?standardId=<standardId>",
    WATERWITHDRAWAL: API_PATH + "/admin/dashboard/graph/water/withdrawal/period/<period>?standardId=<standardId>",
    WATERCONSUMPTION: API_PATH + "/admin/dashboard/graph/water/consumption/period/<period>?standardId=<standardId>",
    SCOPE_123_EMISSION: API_PATH + '/admin/dashboard/graph/emission/scope/period/<period>?standardId=<standardId>',
    SOCIAL_EMPLOYMENT: API_PATH + '/admin/dashboard/graph/social/employment/period/<period>?standardId=<standardId>',
    MONTHLY_DP_BASED_GRAPH: API_PATH + '/admin/dashboard/monthly/datapoint/graph/period/<period>?standardId=<standardId>&type=<type>'
  },
  FILE: {
    UPLOAD: DMS_API_PATH + "/documents/upload/v2?containerId=<containerId>",
    DOWNLOAD: DMS_API_PATH + "/documents/<fileId>/download",
  },
  COUNTRYRISK: {
    LIST: API_PATH + "/context/<encodedUrlParam>/country-scores/period/<date>?pageNumber=<pageNumber>&pageSize=<pageSize>&key=<key>",
    SUBMIT: API_PATH + "/context/<encodedUrlParam>/country-scores/period/<date>"
  },
  PROFILESETTINGS: {
    COMPANYDETAILS: API_PATH + "/companies/<companyId>",
    CHANGEPASSWORD: API_PATH + "/account/change-password",
    UPDATECOMPANYLOGO: API_PATH + "/companies/<companyId>/logo",
    DELETECOMPANYLOGO: API_PATH + "/companies/<companyId>/logo",
    GETCOMPANYLOGO: BASE_URL + API_PATH + "/companies/<companyId>/logo-download",
    ADDBRANCH: API_PATH + "/add/branch/<companyId>",
    GETBRANCH: API_PATH + "/list/branches/<companyId>",
    GET_UTILS: ESG_DATA_SERVICE_PATH + "/util/esg"
  },
  USERACTIVITIES: {
    GETUSERACTIVITIES: API_PATH + "/admin/mis/user-activities?pageSize=<pageSize>&pageNumber=<pageNumber>&sort=<sort>&key=<key>",
  },
  IMPORT: {
    UPLOAD: API_PATH + "/import/supplier/uploadFile",
    DOWNLOAD: API_PATH + "/import/supplier/spreadsheet/download",
    GETIMPORTPROGRESS: API_PATH + "/import/progress/<id>",
    GETSTAGEDATA: API_PATH + "/import/stageData?pageNumber=<pageNumber>&pageSize=<pageSize>",
    UPDATESTAGEDATA: API_PATH + "/import/stagedData/update",
    IMPORTSTAGEDATA: API_PATH + "/import/stagedData/import",
    DELETESTAGEDATA: API_PATH + "/import/stageData",
  },
  DOCUMENTRULES: {
    GENERAL: API_PATH + '/regulations/<regulationId>/document-rules'
  },
  INCIDENTTYPES: {
    LIST: INCIDENT_API_PATH + "/incident-types?pageNumber=<pageNumber>&pageSize=<pageSize>&key=<key>&activeOnly=false",
    SUBMIT: INCIDENT_API_PATH + "/incident-types",
  },
  INCIDENTREPORT: {
    LIST: INCIDENT_API_PATH + "/incident-types",
    // SUBMIT: INCIDENT_API_PATH + "/incident-types",
    REPORTINCIDENT: INCIDENT_API_PATH + "/incidents",
    UPDATE_INCIDENT: INCIDENT_API_PATH + "/incidents/<id>",
    GETINCIDENT: INCIDENT_API_PATH + "/incidents/<id>",
    UPDATESTATUS: INCIDENT_API_PATH + "/incidents/<id>/status/<status>",
    ASSIGNINCIDENT: INCIDENT_API_PATH + "/incidents/<id>/assign/<user>",
    GETINCIDENTACTIVITYLOGS: INCIDENT_API_PATH + "/incidents/<id>/activity-logs",
    CREATECOMMENT: INCIDENT_API_PATH + "/incidents/<id>/notes",
  },
  INCIDENTLIST: {
    LIST: INCIDENT_API_PATH + "/incidents?pageNumber=<pageNumber>&pageSize=<pageSize>&companyId=<companyId>&assignedToMe=<assignedToMe>&createdByMe=<createdByMe>&key=<key>&status=<status>&priority=<priority>&assigneeId=<assigneeId>&reportedCompanyId=<reportedCompanyId>&companyNameId=<companyNameId>&typeId=<typeId>",
  },
  TASK: {
    CREATE_TASK: API_PATH + "/tasks",
    UPDATE_TASK: API_PATH + "/tasks/<taskId>",
    GET_TASK: API_PATH + "/tasks/<taskId>",
    LISTTASKS: API_PATH + "/tasks?pageSize=<pageSize>&pageNumber=<pageNumber>&regulationCode=<regulationCode>&companyId=<companyId>&key=<key>&sort=<sort>",
  },
  USER: {
    GET_USERS: API_PATH + "/users?pageSize=<pageSize>&pageNumber=<pageNumber>&key=<key>&fullyLoad=<fullyLoad>&fetchAll=<fetchAll>&roles=<roles>",
    GET_USERS_BY_GROUP: API_PATH + "/users-by-group",
    CREATE_USER: API_PATH + "/admin/users",
    GET_ALLOWED_ROLES: API_PATH + "/users/allowed-roles",
    GET_USER_DETAILS: API_PATH + "/users/<login>",
    ACTIVATE_USER: API_PATH + "/activate?key=<key>",
    FINISH_PASSWORD_RESET: API_PATH + "/account/reset-password/finish",
    ACCEPT_TERMS: API_PATH + "/users/accept-terms",
    UPDATE_USER: API_PATH + "/admin/users",
  },
  FORGOTPASSWORD: {
    REQUESTRESETLINK: API_PATH + "/account/reset-password/init",
  },
  STANDARDS: {
    CREATE: API_PATH + "/admin/standard",
    GETSTANDARDS: API_PATH + "/admin/regulations?regulationType=<regulationType>",
    // GETSTANDARDS: API_PATH + "/admin/standard",
    ADDTOPIC: API_PATH + "/admin/standard/<standardId>/topic",
    GETTOPICS: API_PATH + "/admin/standard/<standardId>",
    GETMETRICS: API_PATH + "/admin/standard/<standardId>/topic/<topicId>",
    ADDMETRIC: API_PATH + "/admin/standard/topic/<topicId>/metric",
    GETOPICDATA: API_PATH + "/admin/standard/<standardId>/topic/<topicId>",
    EDITTOPIC: API_PATH + "/admin/standard/<standardId>/topic/<topicId>",
    DELETETOPIC: API_PATH + "/admin/standard/<standardId>/topic/<topicId>",
    UPDATESTATUS: API_PATH + "/admin/standard/<standardId>/status/<status>",
    GETSTANDARDDETAILS: API_PATH + "/admin/standard/<standardId>?fullyLoad=<fullyLoad>",
    UPDATESTANDARD: API_PATH + "/admin/standard/<standardId>",
    GETMETRICDETAILS: API_PATH + "/admin/standard/topic/metric/<metricId>",
    DELETEMETRIC: API_PATH + "/admin/standard/topic/metric/<metricId>",
    UPDATEMETRIC: API_PATH + "/admin/standard/topic/metric/<metricId>",
    GETCATEGORY: API_PATH + "/admin/standard/category?standardId=<standardId>",
    GETDATAPOINTS: API_PATH + "/metricparameters/<metricId>",
    ADDDATAPOINT: API_PATH + "/add/metricdatapoint",
    UPDATEDATAPOINT: API_PATH + "/update/metricdatapoint/<dataPointId>",
    DELETEDATAPOINT: API_PATH + "/delete/<dataPointId>",
    GET_PUBLISHED_STANDARDS: API_PATH + "/admin/regulations?regulationType=<regulationType>&status=<status>",
    GET_GROUPED_METRIC_DATA: API_PATH + "/standard/<standardId>/metric/grouped-data?period=<period>&standards=<standards>&lang=<language>&periodStart=<periodStart>&periodEnd=<periodEnd>",
    CONVERSION_TABLE: API_PATH + '/admin/uom/conversion/table',
    GET_ALL_BY_CATEGORY_AND_STANDARD: API_PATH + '/admin/standard/<standardId>/category/<category>/topics?period=<period>&stdCat=<stdCat>',
    GET_METRICS_BY_FILTER: API_PATH + "/standard/<standardId>/metric/data-view/<period>?categoryType=<categoryType>&topicIds=<topicIds>&metricIds=<metricIds>&businessUnitIds=<businessUnitIds>&periodFrom=<periodFrom>&periodTo=<periodTo>&groupIds=<groupIds>",
    GET_METRICS_BY_FILTER_CLCT: API_PATH + "/standard/<standardId>/metric/data-view/<period>?scope=<scope>&emissionIds=<emissionIds>&metricIds=<metricIds>&businessUnitIds=<businessUnitIds>&periodFrom=<periodFrom>&periodTo=<periodTo>",
    GET_METRICS_FOR_TOPICS: API_PATH + "/admin/standard/<standardId>/topic/metrics?topicIds=<topicIds>&cat=<cat>",
    GET_ALL_BY_STANDARD: API_PATH + '/admin/standard/<standardId>/topics?cat=<cat>&catType=<catType>&periodic=<periodic>',
    GET_AGGREGATED_METRIC_DPS: API_PATH + '/standard/<standardId>/metric/datapoint-view/<period>?metricCodes=<metricCodes>&qMetricCodes=<qMetricCodes>&gdQuesCodes=<gdQuesCodes>',
    SAVE_TEMPLATE_FROM_ESG_DATASET: API_PATH + "/admin/standard/<standardId>/template/save",
    GET_QUAN_METRIC_DPS: API_PATH + '/standard/<standardId>/metric/quantitative/<period>/dp-data?metricCodes=<metricCodes>&topicId=<topicId>&periodStart=<periodStart>&periodEnd=<periodEnd>&buIds=<buIds>',
    GET_QUAL_METRIC_QUES_ANS: API_PATH + '/standard/<standardId>/metric/qualitative/<period>/answers?metricCodes=<metricCodes>&topicId=<topicId>&periodStart=<periodStart>&periodEnd=<periodEnd>&buIds=<buIds>',
    GET_METRIC_COMPARE: API_PATH + '/metric/dv/consolidated',
    GET_QUALITATIVE_DATA: API_PATH + '/metric/qualitative/dv/consolidated?regulationId=<standardId>&period=<period>&periodFrom=<periodFrom>&periodTo=<periodTo>&category=<categoryType>&topicIds=<topicIds>&branchIds=<businessUnitIds>',
    GET_QNANS_DATA: API_PATH + '/metric/question/dv/consolidated?metricId=<metricId>&period=<period>&branchIds=<businessUnitIds>',
    POST_QUAL_METRIC_ANS: API_PATH + "/metric/answer/<period>/bulk",
    GET_DOCUMENTS_ATTACHED: DMS_API_PATH + "/documents/<externalId>/download",
    UPLOAD_ATTACHMENTS: API_PATH + "/files/upload",
    SAVE_COMMENTS_ATTACHMENTS: API_PATH + "/metric/answer/<date>/remarks",
    GET_DOCUMENTS_ATTACHED_ALT: API_PATH + "/attachments/<id>/download",
    EXPORT_COMPARE_DATA: API_PATH + '/download/metric/dv/consolidated',
    GET_ESG_TOPICS: API_PATH + '/admin/standard/<standardId>/esg/topics?lang=<lang>',
    SAVE_UOM_TABLE_ROW: API_PATH + '/admin/uom',
    UPDATE_UOM_TABLE_ROW: API_PATH + '/admin/uom/<id>',
    GET_SCOPE_CAT: API_PATH + '/emission/metric/<standardId>/scopes',
    GET_METRIC_DATAPOINT: API_PATH + '/emission/metric/<standardId>',
    GET_METRIC_DATAPOINT_LIST: API_PATH + '/emission/metric/<metricId>/datapoint/<standardId>?periodFrom=<periodFrom>',
    GET_GHG_METRIC_DATA: API_PATH + '/emission/metric/<standardId>?scope=<scope>&category=<category>&businessUnitIds=<businessUnitIds>&periodFrom=<periodFrom>&periodTo=<periodTo>',
    FINALIZE_CONFIG: API_PATH + '/standard/<standardId>/finalize-config',
    GET_GHG_DATAPOINTS: API_PATH + '/emission/metric/<metricId>/datapoint/<standardId>',
    GET_DP_PAGE: API_PATH + '/standard/<stdId>/datapoint/all?pageSize=<pageSize>&pageNumber=<pageNumber>&dsLinked=<dsLinked>&fetchAll=<fetchAll>',
    GET_ALL_METRICS_DATAPOINTS: API_PATH + '/admin/standard/<standardId>/metrics/dps/all?topicIds=<topicIds>&sCat=<sCat>',
    GET_TOPICS_METRICS_DPS: API_PATH + '/standard/<standardId>/topics-metrics-dps?category=<cat>&topicIds=<topicIds>&metricIds=<metricIds>&dpIds=<dpIds>',
    REORDER_TOPIC: API_PATH + "/admin/standard/<standardId>/topic/<topicId>/reorder",
    REORDER_DATAPOINT: API_PATH + "/reorder/metricdatapoint/<dataPointId>",
    REORDER_METRIC: API_PATH + "/admin/standard/topic/metric/<metricId>/reorder",
    REORDER_QUESTION: API_PATH + "/metric/question/<questionId>/reorder",
    EXPORT_STANDARD_CONFIG_PARTIAL: API_PATH + "/admin/standard-export/<standardId>",
    IMPORT_TOPICS: API_PATH + "/admin/standard-import/<standardId>/topics",
    IMPORT_METRICS: API_PATH + "/admin/standard-import/<standardId>/topic/<topicId>/metrics",
    IMPORT_DATAPOINTS: API_PATH + "/admin/standard-import/<standardId>/metric/<metricId>/datapoints",
    MOVE_METRICS_TO_TOPIC: API_PATH + "/admin/standard/topic/<topicId>/metric/move",
    MOVE_DATAPOINTS_TO_METRIC: API_PATH + "/metric/<metricId>/datapoint/move",
    GET_METRICS_BY_FILTER_V2: API_PATH + "/standard/<standardId>/metric/data-view/<period>/v2?categoryType=<categoryType>&topicIds=<topicIds>&metricIds=<metricIds>&businessUnitIds=<businessUnitIds>&periodFrom=<periodFrom>&periodTo=<periodTo>&groupIds=<groupIds>",
  },
  KPI: {
    GETMETRIC: API_PATH + "/standard/<standardId>/metric/data-points/<date>",
    SAVEDATAPOINT: API_PATH + "/standard/<standardId>/metric/data-points/<date>/bulk-update",
    DOWNLOADTEMPLATE: API_PATH + "/download/metric/data/excel/template/<standardId>/period/<date>",
    UPLOAD: API_PATH + "/upload/metric/data/excel/standard/<standardId>/period/<date>",
    IMPORT_STATUS: API_PATH + "/metric/data/excel/import/status",
    IMPORT_DATA: API_PATH + "/import/metric/data/standard/<standardId>/period/<date>",
    CATEGORY: {
      CREATE: KPI_SERVICE_PATH + '/goal/category',
      LIST: KPI_SERVICE_PATH + '/goal/category?ownerId=<ownerId>',
      UPDATE: KPI_SERVICE_PATH + '/goal/category',
      DELETE: KPI_SERVICE_PATH + '/goal/category?goalCategoryId=<goalCategoryId>',
    },
    GET_KPI_METRICS: API_PATH + '/admin/standard/topic/metrics',
    DATAPOINT: {
      CREATE: KPI_SERVICE_PATH + '/master/data-point',
      LIST: KPI_SERVICE_PATH + '/master/data-point?ownerId=<ownerId>',
      UPDATE: KPI_SERVICE_PATH + '/master/data-point',
      DELETE: KPI_SERVICE_PATH + '/master/data-point?dataPointId=<dataPointId>',
    },
    GOAL: {
      CREATE: KPI_SERVICE_PATH + '/goal',
      LIST: KPI_SERVICE_PATH + '/goal?ownerId=<ownerId>&category=<category>',
      LIST_PAGED: KPI_SERVICE_PATH + '/goal/page?ownerId=<ownerId>&page=<pageNumber>&size=<pageSize>&type=<type>',
      DELETE: KPI_SERVICE_PATH + '/goal?goalId=<goalId>',
      DELETE_KPI: KPI_SERVICE_PATH + '/goal/kpi?kpiId=<id>',
      DELETE_ACTION: KPI_SERVICE_PATH + '/goal/action?actionId=<id>',
      DELETE_DP: KPI_SERVICE_PATH + '/goal/dp?dpId=<id>'
    },
    KPI: {
      LIST_PAGED: KPI_SERVICE_PATH + '/kpi/data?ownerId=<ownerId>&page=<pageNumber>&size=<pageSize>&period=<period>&category=<category>&goalId=<goalId>&kpiId=<kpiId>&assigneeId=<assigneeId>',
      UPSERT: KPI_SERVICE_PATH + '/kpi/data/upsert',
      UPSERT_KPI: KPI_SERVICE_PATH + '/kpi?goalId=<goalId>',
      GET_KPIS: KPI_SERVICE_PATH + '/kpi?goalId=<goalId>',
      DELETE_KPI: KPI_SERVICE_PATH + '/kpi?kpiId=<kpiId>',
    },
    ACTION: {
      UPSERT: KPI_SERVICE_PATH + '/action?kpiId=<kpiId>',
      GET: KPI_SERVICE_PATH + '/action?kpiId=<kpiId>',
      DELETE: KPI_SERVICE_PATH + '/action?actionId=<actionId>',
      FILTER: KPI_SERVICE_PATH + '/action/filter?ownerId=<ownerId>&category=<category>&goalId=<goalId>&kpiId=<kpiId>&assigneeId=<assigneeId>',
      UPSERT_PROGRESS: KPI_SERVICE_PATH + '/action/progress?actionId=<actionId>',
      GET_PROGRESS: KPI_SERVICE_PATH + '/action/progress?actionId=<actionId>',
      DELETE_PROGRESS: KPI_SERVICE_PATH + '/action/progress?progressId=<progressId>',
    },
    GRAPH: {
      GET_BY_GOAL: KPI_SERVICE_PATH + '/graph/goal/<goalId>/period/<period>?ownerId=<ownerId>',
      GET_BY_KPI: KPI_SERVICE_PATH + '/graph/kpi/<kpiId>/period/<period>?ownerId=<ownerId>',
      GET_ACTIONS: KPI_SERVICE_PATH + '/graph/action/goal/<goalId>/period/<period>?ownerId=<ownerId>&kpiId=<kpiId>&businessUnitId=<businessUnitId>'
    }
  },
  BRANCHDATAMETRIC: {
    GETMETRIC: API_PATH + "/branch/standard/<standardId>/metric/<metricId>/data-points/<date>",
    SAVEDATAPOINT: API_PATH + "/branch/standard/<standardId>/metric/data-points/<date>/bulk-update",
    DATA_POINT_CONSOLIDATED: API_PATH + "/metric/dp/dv/consolidated",
    GET_DOCUMENTS_ATTACHED: DMS_API_PATH + "/documents/<externalId>/download",
    UPLOAD_ATTACHMENTS: API_PATH + "/files/upload",
    SAVE_COMMENTS_ATTACHMENTS: API_PATH + "/branch/standard/<standardId>/metric/data-points/<date>/remarks",
    GETMETRIC_V2: API_PATH + "/branch/standard/<standardId>/metric/<metricId>/data-points/<date>/v2",
  },
  EQUATIONDATA: {
    GETCONFIG: API_PATH + "/admin/equation/standard/<standardId>/topic/<topicId>/metric/<metricId>",
    GETCONFIG_ADMIN: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/equation/standard/<standardId>/topic/<topicId>/metric/<metricId>",
    SAVEDATA: API_PATH + '/admin/equation/standard/topic/metric/<metricId>',
    CALCULATE: API_PATH + '/admin/execute/equation/standard/topic/metric/<metricId>/period/<date>',
    EXECUTION_STATUS: COCKPIT_ALCHEMY_PATH + '/equation/delta-execution/status/<companyId>',
    GET_COMPONENTS: API_PATH + '/equation/standard/<standardId>/components?eqId=<eqId>'
  },
  RISK: {
    GETMETRICDATA: API_PATH + "/standard/<standardId>/metricdetails/<date>",
    GETMETRICDETAILSTABLE: API_PATH + "/standard/metric/branch/<standardId>/<metricId>/<date>",
    EXPORTTOEXCEL: API_PATH + "/export/excel"
  },
  ANALYTICSREPORT: {
    GETMETRICDATA: API_PATH + "/graphdetails/standrad/<standardId>/metric/<metricCode>/data-points/period/<period>?key=<key>",
    GET_COMBINED_METRIC_DATA_BY_RANGE: API_PATH + "/graphdetails/standrad/<standardId>/metric/<metricCode>/data-points?key=<key>&periodfrom=<periodfrom>&periodto=<periodto>&branch=<branch>",
    EXPORT: API_PATH + "export/graphdetails/standard/<standardId>/metric/<metricCode>/data-points?key=<key>&periodfrom=<periodfrom>&periodto=<periodto>&branch=<branch>",
    GET_ANALYTICS: API_PATH + '/standard/<standardId>/metric/data/analytics?type=<type>&periodFrom=<periodFrom>&periodTo=<periodTo>'
  },
  OFFICE_PAGES: {
    GET_PAGES: API_PATH + "/admin/office-pages/<type>?pageNumber=<pageNumber>&pageSize=<pageSize>",
    ADD_PAGE: API_PATH + "/admin/office-pages",
    GET_ACTIVE_PAGE: API_PATH + "/admin/office-pages/activePage/<type>",
  },
  ASSESSMENTS: {
    SAVE: FORM_BUILDER_PATH + '/assessments',
    GET_FORM_PREVIEW: FORM_BUILDER_PATH + '/forms/<formId>/preview?no-cache=<no-cache>',
    CREATE_GROUP: API_PATH + '/assessment/groups',
    LIST_GROUPS: API_PATH + '/assessment/groups',
    LIST_GROUPS_PAGINATED: API_PATH + '/assessment/groups/page?pageNumber=<pageNumber>&pageSize=<pageSize>&sort=<sort>',
    LIST: FORM_BUILDER_PATH + "/assessments?pageNumber=<pageNumber>&pageSize=<pageSize>&regulationId=<regulationId>&selfAssessment=<selfAssessment>&sort=<sort>&fetchFieldSectionCounts=<fetchFieldSectionCounts>&name=<name>&type=<type>&year=<year>",
    LIST_V2: FORM_BUILDER_PATH + "/assessments/v2?pageNumber=<pageNumber>&pageSize=<pageSize>&sort=<sort>&type=<type>&selfAssessment=<selfAssessment>&submissionStatus=<submissionStatus>&fetchFieldSectionCounts=<fetchFieldSectionCounts>&year=<year>",
    LIST_V2_PERIOD: FORM_BUILDER_PATH + "/assessments/v2?pageNumber=<pageNumber>&pageSize=<pageSize>&sort=<sort>&type=<type>&selfAssessment=<selfAssessment>&submissionStatus=<submissionStatus>&fetchFieldSectionCounts=<fetchFieldSectionCounts>&periodStart=<periodStart>&periodEnd=<periodEnd>",
    SHARE: FORM_BUILDER_PATH + "/assessments/<id>/share",
    UPDATE_GROUP: API_PATH + '/assessment/groups/<groupId>',
    DELETE_GROUP: API_PATH + '/assessment/groups/<groupId>',
    GET_FOR_PERIOD: FORM_BUILDER_PATH + '/assessments/forms/<formId>/period/<period>',
    GET: FORM_BUILDER_PATH + '/assessments/<id>',
    UPDATE: FORM_BUILDER_PATH + '/assessments/<id>',
    GET_SUBMISSIONS: FORM_BUILDER_PATH + '/assessments/<id>/form-data?pageNumber=<pageNumber>&pageSize=<pageSize>&sort=<sort>&key=<key>&toReview=<toReview>&status=<status>',
    GET_SUPPLIER_SUBMISSIONS: FORM_BUILDER_PATH + '/assessments/shared-with-me?pageNumber=<pageNumber>&pageSize=<pageSize>&sort=<sort>',
    SHARE_SUBMISSION: FORM_BUILDER_PATH + "/assessments/<id>/share/submission",
    GET_SHARED_BRANCEHS: FORM_BUILDER_PATH + "/assessments/<id>/shared-branches",
    RE_SHARE: FORM_BUILDER_PATH + "/assessments/<id>/re-share",
    SEND_REMINDER: FORM_BUILDER_PATH + "/assessments/<id>/remind",
    GET_BRANCH_SUBMISSIONS: FORM_BUILDER_PATH + "/assessments/<id>/branch/submissions?pageNumber=<pageNumber>&pageSize=<pageSize>&status=<status>",
    GET_FORM_DATA_LOGS: FORM_BUILDER_PATH + "/form-data/<submissionId>/logs",
    EXPORT_GROUPS_EXCEL: API_PATH + '/assessment/groups/export/excel',
    EXPORT_GROUPS_TEMPLATE: API_PATH + '/assessment/groups/export/template',
    IMPORT_GROUPS: API_PATH + '/assessment/groups/import',
    REVOKE_FORM_SUBMISSION: FORM_BUILDER_PATH + "/form-data/<submissionId>/revoke",
    GET_BRANCH_SUBMISSIONS_SUMMARY: FORM_BUILDER_PATH + "/assessments/branch/submissions/summary?periodStart=<periodStart>&periodEnd=<periodEnd>&fetchsummary=true&pageNumber=<pageNumber>&pageSize=<pageSize>",
    GET_BRANCH_SUBMISSIONS_FREQUENCY: FORM_BUILDER_PATH + "/assessments/branch/submissions/summary?periodStart=<periodStart>&periodEnd=<periodEnd>&fetchfrequency=true",
    GET_BRANCH_SUBMISSIONS_BY_STATUS: FORM_BUILDER_PATH + "/assessments/branch/submissions/summary?periodStart=<periodStart>&periodEnd=<periodEnd>&fetchbranch=true&status=<status>",
    GET_BRANCH_SUBMISSIONS_BY_FREQUENCY_STATUS: FORM_BUILDER_PATH + "/assessments/branch/submissions/summary?periodStart=<periodStart>&periodEnd=<periodEnd>&fetchbranch=true&frequency=<frequency>&status=<status>&pageNumber=<pageNumber>&pageSize=<pageSize>&reportingPeriod=<reportingPeriod>",
    EXPORT_BRANCH_SUBMISSIONS_SUMMARY: FORM_BUILDER_PATH + "/assessments/branch/submissions/summary/export?periodStart=<periodStart>&periodEnd=<periodEnd>",

  },
  FORM: {
    // Same section endpoint the form builder uses; a body with parentSection creates a sub-section
    CREATE_FORM_SECTION: FORM_BUILDER_PATH + "/forms/<formId>/sections",
    // Units the form builder offers for a section/question UOM
    GET_FORM_UNITS_OF_MEASURE: FORM_BUILDER_PATH + "/util/units?companyId=<companyId>",
    // Form builder form details; selectedLanguage is required when creating a section
    GET_FORM_DETAILS: FORM_BUILDER_PATH + "/forms/<formId>",
    DELETE_FORM_SECTION: FORM_BUILDER_PATH + "/forms/<formId>/sections/<sectionId>?deleteChildren=<deleteChildren>",
    // Form builder question move: body { sectionId, prevFieldId } places the field after prevFieldId (0 = first)
    REORDER_FORM_FIELD: FORM_BUILDER_PATH + "/forms/<formId>/fields/<fieldId>",
    // Form builder section move: body { sectionId: parentId, prevSectionId } places the section under parentId after prevSectionId (0 = first)
    REORDER_FORM_SECTION: FORM_BUILDER_PATH + "/forms/<formId>/sections/<sectionId>",
  },
  GENERAL_DISCLOSURE: {
    GET_LIST: API_PATH + "/admin/disclosures",
    CREATE: API_PATH + "/admin/disclosures",
    UPDATE: API_PATH + "/admin/disclosures/<disclosureId>",
    GET: API_PATH + "/admin/disclosures/<disclosureId>?fullyLoad=<fullyLoad>",
    GET_QUESTION: API_PATH + "/admin/disclosure/<disclosureId>/question/<questionId>",
    ADD_QUESTION: API_PATH + "/admin/disclosure/<disclosureId>/question",
    UPDATE_QUESTION: API_PATH + "/admin/disclosure/<disclosureId>/question/<questionId>",
    DELETE_QUESTION: API_PATH + "/admin/disclosure/<disclosureId>/question/<questionId>",
    UPSERT_QUESTION: API_PATH + "/admin/disclosure/<disclosureId>/question/upsert",
    GET_ALL_QUESTIONS: API_PATH + "/admin/disclosure/question?category=<category>",
    SAVE_ANSWER_BULK: API_PATH + "/disclosure/bulk/answer/<period>",
    DELETE_ANSWER: API_PATH + "/disclosure/<disclosureId>/answer/<answerId>",
    GET_STANDARD_TYPES: API_PATH + "/admin/disclosures/std-types",
    GET_QUESTIONS_AND_ANSWERS: API_PATH + "/disclosure/<standardType>/answer/<period>?lang=<lang>&periodStart=<periodStart>&periodEnd=<periodEnd>&buIds=<buIds>",
    GET_PAGED_QUESTIONS_AND_ANSWERS: API_PATH + "/disclosure/<standardType>/answer/<period>/page?pageSize=<pageSize>&pageNumber=<pageNumber>",
    GET_QUESTIONS_AND_ANSWERS_BY_CODE: API_PATH + "/disclosure/question/answers/<period>?questionCodes=<questionCodes>&periodStart=<periodStart>&periodEnd=<periodEnd>",
    DELETE_ANSWERS_BULK: API_PATH + "/disclosure/<disclosureId>/answer/bulk",
    SAVE_REMARK_ATTACHMENTS: API_PATH + "/disclosure/answer/<period>/remark-attachments",
  },
  REPORT_AI: {
    REPORTING_OVERVIEW: '/esg/overview_reporting',
    ESG_HIGHLIGHTS: COPILOT_PATH + '/esg_highlights',
    STREAM_ESG_HIGHLIGHTS: '/esg/stream_esg_highlights',
    STREAM_REPORTING_OVERVIEW: '/esg/stream_overview',
    CHECK_JOB_STATUS: COPILOT_PATH + '/check_autodraft_status/<jobId>',
    COLLECT_REPORT_DATA: COPILOT_PATH + '/get_autodraft_results/<jobId>',
    STREAM_ESG: '/esg/esg_section',
    MATERIAL_TOPIC: '/esg/material_topic',
    GET_PERSONALITIES: '/esg/get_personalities_master',
    GET_COMPANY_PERSONALIIES: '/esg/get_personality_company/<companyId>',
    UPDATE_COMPANY_PERSONALITY: '/esg/update_company_personality',
    GET_SECTIONS: '/esg/get_sections_master',
    GET_COMPANY_SECTIONS: '/esg/get_company_sections/<companyId>',
    SET_COMPANY_SECTIONS: '/esg/set_company_sections',
    UPDATE_COMPANY_SECTIONS: '/esg/company_sections',
    REMOVE_COMPANY_SECTIONS: '/esg/remove_company_sections',
    CHAT_WITH_DATA: '/ai/nlq4metric',
    GET_STYLES: '/esg/get_styles_master',
    GET_COMPANY_STYLES: '/esg/get_company_styles/<companyId>',
    UPDATE_COMPANY_STYLES: '/esg/update_company_styles',
    GET_TONES: '/esg/get_tones_master',
    GET_COMPANY_TONES: '/esg/get_company_tones/<companyId>',
    UPDATE_COMPANY_TONES: '/esg/update_company_tones',
    FEEDBACK: '/esg/feedback',
    FEEDBACK_FROM_CHAT_BOT: '/ai/feedback',
    GET_HISTORY: '/ai/getcwdhistory/<companyId>/<userId>/<startLimit>/<endLimit>',
    DEL_HISTORY: '/ai/delcwdhistory/<companyId>/<userId>',
    VISUALIZE: '/ai/visualize/<companyId>/<logId>',
    CHECK_CODRAFT_JOB_STATUS: COPILOT_PATH + '/esg_highlights_status/<jobId>',
    BRSR_REPHRASED_ANS: '/esg/brsr_rephrase',
    BRSR_XBRL_GENERATE: '/copilot/brsr_xbrl_generate',
    GET_CWD_ID: '/ai/cwdinit/v1',
    CLEAR_CWD_ID: '/ai/cwddel/v1',
    GET_CLASSIFICATION: '/ai/classification/v1',
    PROCESS_NEW: '/ai/nlq4metric/v1',
    CHAT_WITH_DATA_NEW: '/ai/nlg4metric/v1',
    MATERIAL_TOPIC_ESRS: '/esg/esrsXBRL/v1',
    REPORT_CONTENT_GEN: '/esg/report_content_gen',
    REPORT_CONTENT_GEN_NEW: '/copilot/ai_copilot',
    FILE_UPLOAD_EXTRACT: '/copilot/upload_file',
    GET_FILE_UPLOAD: '/copilot/get_uploaded_files?company_id=<companyId>',
  },
  DASH_GRAPH_CONFIG: {
    LIST: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config/page?page=<pageNumber>&size=<pageSize>&companyId=<companyId>&category=<category>&standardName=<standardName>&key=<key>",
    GET_PROPS: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config/properties?type=<type>",
    CREATE: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config",
    UPDATE: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config",
    DELETE: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config/id/<id>",
    GET: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config/page?companyId=<companyId>&category=<category>&standardName=<standardName>&topicName=<topicName>",
    GET_COMPANY_GRAPHS: API_PATH + "/dynamic/graph/config/standard/<standard>?fetchAll=<fetchAll>&standardName=<standardName>&category=<category>&topicName=<topicName>&emission=<emission>&active=<active>&scope=<scope>&scopeCategory=<scopeCategory>&layout=<layout>",
    CHANGE_STATUS: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config/status/id/<id>?companyId=<companyId>",
    LIST_UNPAGED: API_PATH + "/dynamic/graph/config?category=<category>",
    ASSIGN_TO_COMPANY: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config/assign/company/<companyId>",
    GET_GRAPH: API_PATH + "/dynamic/graph/id/<graphId>/period/<period>/standardId/<standardId>?businessUnitId=<businessUnitId>&interval=<interval>&offset=<offset>",
    GET_GRAPH_WITH_METRICS: API_PATH + "/dynamic/graph/standard/<standardId>/metric/filtered-data?metricIds=<metricIds>&metricDataPointIds=<metricDataPointIds>&periodFrom=<periodFrom>&periodTo=<periodTo>&businessUnitIds=<businessUnitIds>",
    GET_DATA_VIEW: API_PATH + "/dynamic/graph/standard/<standardId>/dynamic-graph/<graphId>/data-view/<period>?categoryType=<categoryType>&businessUnitIds=<businessUnitIds>&periodFrom=<periodFrom>&periodTo=<periodTo>&interval=<interval>&offset=<offset>&aggregationType=<aggregationType>&includeTrends=<includeTrends>",
    ACTIVATE_GRAPH: API_PATH + "/dynamic/graph/config/<id>/activate/<status>",
    SAVE_GRAPH_LAYOUT: API_PATH + "/dynamic/graph/config/standard/<standardId>/layout",
    CREATE_GRAPH_SET: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config/set",
    LIST_GRAPH_SETS: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config/set/page?page=<pageNumber>&size=<pageSize><keyQuery>",
    ASSIGN_SET_TO_COMPANY: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config/set/<id>/assign",
    DELETE_GRAPH_SET: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config/set/<id>",
    UNASSIGN_SET_FROM_COMPANY: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config/set/<id>/assign/<companyId>",
    UPDATE_GRAPH_SET: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config/set/<id>",
    UPDATE_COMPANY_GRAPH: API_PATH + "/dynamic/graph/config"
  },
  CARBON_EMISSION: {
    GET_EMISSIONS: API_PATH + "/emission/calculator?scope=<scope>&category=<category>&db=<db>&period=<period>&businessUnitId=<businessUnitId>",
    GET_CATS: API_PATH + "/emission/calculator/category/scope/<scope>",
    GET_LEVELS: API_PATH + "/emission/calculator/level/db/<db>/scope/<scope>?category=<category>&level=<level>&level1=<level1>&level2=<level2>&level3=<level3>&level4=<level4>&level5=<level5>",
    GET_UOM: API_PATH + "/emission/calculator/uom/db/<db>/scope/<scope>?level1=<level1>&level2=<level2>&level3=<level3>&level4=<level4>&level5=<level5>",
    GET_LIVE_DATA: API_PATH + "/emission/calculator/live/data",
    CAPTURE: API_PATH + "/emission/calculator?standardId=<standardId>",
    GET_CATEGORIZED_EMISSIONS: API_PATH + "/emission/calculator/category/data?db=<db>&period=<period>&ghgUnit=<ghgUnit>&businessUnitId=<businessUnitId>",
    GET_GHG: API_PATH + "/emission/calculator/ghg/unit",
    GET_FIELDS: API_PATH + "/emission/calculator/field/level?uom=<uom>",
    GET_AGGREGATED_EMISSION: API_PATH + "/emission/calculator/aggregated/emission?scope=<scope>&period=<period>&businessUnitId=<businessUnitId>",
    DELETE: API_PATH + "/emission/calculator?id=<id>&standardId=<standardId>",
    GET_DB: API_PATH + "/emission/calculator/db",
    GET_BY_BRANCH_FOR_GHG_REPORT: API_PATH + "/emission/branch/data/<standardId>/<period>?metricCode=<metricCode>",
    GET_BY_COUNTRY_FOR_GHG_REPORT: API_PATH + "/emission/country/data/<standardId>/<period>?metricCode=<metricCode>",
    GET_EMISSION_DATA_FOR_GHG_REPORT: API_PATH + "/emission/data/<standardId>/<period>?metricCode=<metricCode>"
  },
  CONSULTANT: {
    GET_COMPANIES: API_PATH + "/consultants/companies",
    SWITCH_COMPANY: API_PATH + "/consultants/companies/<companyId>"
  },
  ESG_DATASET: {
    ADD_TOPIC: ESG_DATA_SERVICE_PATH + "/master/topic",
    UPDATE_TOPIC: ESG_DATA_SERVICE_PATH + "/master/topic",
    GET_TOPIC: ESG_DATA_SERVICE_PATH + "/master/topic?id=<id>&category=<category>",
    DELETE_TOPIC: ESG_DATA_SERVICE_PATH + "/master/topic?id=<id>",
    ADD_METRIC: ESG_DATA_SERVICE_PATH + "/master/metric?topicId=<topicId>&parentId=<parentId>",
    GET_METRIC: ESG_DATA_SERVICE_PATH + "/master/metric?topicId=<topicId>&id=<id>&standard=<standard>",
    UPDATE_METRIC: ESG_DATA_SERVICE_PATH + "/master/metric",
    DELETE_METRIC: ESG_DATA_SERVICE_PATH + "/master/metric?id=<id>",
    ADD_DP: ESG_DATA_SERVICE_PATH + "/master/data-point?metricId=<metricId>",
    UPDATE_DP: ESG_DATA_SERVICE_PATH + "/master/data-point",
    GET_DP: ESG_DATA_SERVICE_PATH + "/master/data-point?metricId=<metricId>&id=<id>&standard=<standard>",
    DELETE_DP: ESG_DATA_SERVICE_PATH + "/master/data-point?id=<id>",
    UPSERT_EQ: ESG_DATA_SERVICE_PATH + "/master/equation/upsert?metricId=<metricId>",
    GET_EQ: ESG_DATA_SERVICE_PATH + "/master/equation/config?topicId=<topicId>",
    GET_PLATFORM_STD: ESG_DATA_SERVICE_PATH + "/platform/standard",
    GET_PLATFORM_STD_CODE: ESG_DATA_SERVICE_PATH + "/platform/standard/code/mapping?standard=<standard>&category=<category>&platformCode=<platformCode>",
    MAP_PLATFORM_CODE: ESG_DATA_SERVICE_PATH + "/platform/standard/code/mapping",
    DELETE_PLATFORM_CODE_MAP: ESG_DATA_SERVICE_PATH + "/platform/standard/code/mapping?standard=<standard>&platformCode=<platformCode>",
    REORDER_TOPIC: ESG_DATA_SERVICE_PATH + "/master/topic/<topicId>/reorder",
    REORDER_METRIC: ESG_DATA_SERVICE_PATH + "/master/metric/<metricId>/reorder",
    REORDER_DP: ESG_DATA_SERVICE_PATH + "/master/data-point/<dataPointId>/reorder",
  },
  SUPER_ADMIN_STD: {
    CREATE_STANDARD: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard",
    UPDATE_STANDARD: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/<standardId>",
    GET_STANDARDS: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/regulations?regulationType=<regulationType>",
    GET_PUBLISHED_REGULATIONS: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/regulations?status=PUBLISHED",
    GET_REGULATIONS_WITH_TYPE: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/regulations?regulationType=<regulationType>",
    UPDATE_STATUS: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/<standardId>/status/<status>",
    GET_CATEGORY: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/category?standardId=<standardId>",
    GET_TOPICS: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/<standardId>",
    GET_METRICS: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/<standardId>/topic/<topicId>",
    GET_DATAPOINTS: ADMIN_TEMPLATE_SERVICE_PATH + "/metricparameters/<metricId>",
    SAVE_TEMPLATE_FROM_ESG_DATASET: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/<standardId>/template/save",
    DELETE_TOPIC: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/<standardId>/topic/<topicId>",
    DELETE_METRIC: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/topic/metric/<metricId>",
    DELETE_DATAPOINT: ADMIN_TEMPLATE_SERVICE_PATH + "/delete/<dataPointId>",
    GET_TOPIC_DATA: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/<standardId>/topic/<topicId>",
    ADD_TOPIC: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/<standardId>/topic",
    EDIT_TOPIC: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/<standardId>/topic/<topicId>",
    ADD_METRIC: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/topic/<topicId>/metric",
    UPDATE_METRIC: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/topic/metric/<metricId>",
    GET_METRIC_DETAILS: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/topic/metric/<metricId>",
    ADD_DATAPOINT: ADMIN_TEMPLATE_SERVICE_PATH + "/add/metricdatapoint",
    UPDATE_DATAPOINT: ADMIN_TEMPLATE_SERVICE_PATH + "/update/metricdatapoint/<dataPointId>",
    LIST_DS_BY_STANDARD: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/regulations/<regulationId>/data-sources?configType=<configType>&parentId=<parentId>&quantitative=<quantitative>",
    SAVE_DS_BY_STANDARD: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/regulations/<regulationId>/param/<paramId>/data-sources/<dsId>?paramType=<paramType>",
    UNLINK_DS: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/regulations/<regulationId>/param/<riskId>/data-sources?paramType=<paramType>",
    GET_ALL_BY_STANDARD: ADMIN_TEMPLATE_SERVICE_PATH + '/admin/standard/<standardId>/topics',
    EXPORT_STANDARD_CONFIG_PARTIAL: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard-export/<standardId>",
    IMPORT_TOPICS: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard-import/<standardId>/topics",
    IMPORT_METRICS: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard-import/<standardId>/topic/<topicId>/metrics",
    IMPORT_DATAPOINTS: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard-import/<standardId>/metric/<metricId>/datapoints",
    MOVE_METRICS_TO_TOPIC: ADMIN_TEMPLATE_SERVICE_PATH + "/admin/standard/topic/<topicId>/metric/move",
    MOVE_DATAPOINTS_TO_METRIC: ADMIN_TEMPLATE_SERVICE_PATH + "/metric/<metricId>/datapoint/move",
    GET: ADMIN_TEMPLATE_SERVICE_PATH + "/dynamic/graph/config/page?companyId=<companyId>&category=<category>&standardName=<standardName>&topicName=<topicName>",
  },
  SUPER_ADMIN_GD: {
    GET_LIST: ESG_DATA_SERVICE_PATH + "/master/disclosures",
    CREATE: ESG_DATA_SERVICE_PATH + "/master/disclosures",
    UPDATE: ESG_DATA_SERVICE_PATH + "/master/disclosures/<disclosureId>",
    GET: ESG_DATA_SERVICE_PATH + "/master/disclosures/<disclosureId>?fullyLoad=<fullyLoad>",
    GET_QUESTION: ESG_DATA_SERVICE_PATH + "/master/disclosure/<disclosureId>/question/<questionId>",
    ADD_QUESTION: ESG_DATA_SERVICE_PATH + "/master/disclosure/<disclosureId>/question",
    UPDATE_QUESTION: ESG_DATA_SERVICE_PATH + "/master/disclosure/<disclosureId>/question/<questionId>",
    DELETE_QUESTION: ESG_DATA_SERVICE_PATH + "/master/disclosure/<disclosureId>/question/<questionId>",
    UPSERT_QUESTION: ESG_DATA_SERVICE_PATH + "/master/disclosure/<disclosureId>/question/upsert",
    GET_ALL_QUESTIONS: ESG_DATA_SERVICE_PATH + "/master/disclosure/<disclosureId>/question",
    GET_ALL_QUESTIONS_FOR_STD: ESG_DATA_SERVICE_PATH + "/master/disclosure/question/<stdType>",
  },
  PARTNER: {
    GET_ALL_PARTNERS: PARTNER_SERVICE_PATH + "/api/partners/all",
    SAVE_UI_CONFIG: PARTNER_SERVICE_PATH + "/api/partners/<partnerId>/uiconfig",
    GET_UI_CONFIG: PARTNER_SERVICE_PATH + "/api/partners/uiconfig",
    GET_PARTNER_SPECIFIC_UI_CONFIG: PARTNER_SERVICE_PATH + "/api/partners/<partnerId>/uiconfig",
  },
  DATA_COLLECTION_EVENT: {
    CREATE: API_PATH + "/dce",
    UPDATE: API_PATH + "/dce/<id>",
    GET: API_PATH + "/dce/<id>",
    SHARE: API_PATH + '/dce/<id>/share',
    LIST: API_PATH + "/dce/<regulationId>/list?pageNumber=<pageNumber>&sort=<sort>&pageSize=<pageSize>",
    GET_SHARE_DETAILS: API_PATH + '/dce/<id>/share/details?pageNumber=<pageNumber>&pageSize=<pageSize>',
  },
  CONTENT_BLOCK: {
    GET_CONTENT_BLOCKS: API_PATH + "/content-block/<standardId>/period/<period>/list?type=<type>",
    GET_CONTENT_BLOCKS_DETAILS: API_PATH + "/content-block/<id>",
    CREATE_CONTENT_BLOCK: API_PATH + "/content-block",
    UPDATE_CONTENT_BLOCK: API_PATH + "/content-block/<id>",
    CONTENT_FROM_FILE: "/ai_benchmark/get_esg_file_content/v1",
    CONTENT_FROM_URL: "/ai_benchmark/get_esg_url_content/v1",
    CONTENT_BLOCK_TOPICS: API_PATH + "/admin/standard/<standardId>/topics/all",
    GET_CONTENT_BLOCKS_FOR_TOPIC: API_PATH + "/content-block/<standardId>/period/<period>/topic/<topicId>/list?periodStart=<periodStart>&periodEnd=<periodEnd>",
  },
  DATA_VIEW: {
    EXPORT_METRIC_DATAVIEW: API_PATH + "/download/metric/data/excel/template/<standardId>/period/<date>?categoryType=<categoryType>&businessUnitIds=<businessUnitIds>&topicIds=<topicIds>",
    EXPORT_METRIC_DATAVIEW_NEW: API_PATH + "/download/report/metric/data/excel/template/<standardId>/period/<date>?categoryType=<categoryType>&businessUnitIds=<businessUnitIds>&topicIds=<topicIds>&periodFrom=<periodFrom>&periodTo=<periodTo>&showTotalReportedValue=<showTotalReportedValue>",
    EXPORT_METRIC_DATA_ATTACHMENTS: API_PATH + "/metric/attachments/download/<standardId>/<date>?businessUnitIds=<businessUnitIds>&topicIds=<topicIds>&categoryType=<categoryType>"
  },
  EMISSION_FACTOR_LINK: {
    GET_EMISSIONS: API_PATH + "/emission/calculator?scope=<scope>&category=<category>&db=<db>&period=<period>&businessUnitId=<businessUnitId>",
    GET_CATS: API_PATH + "/emission/calculator/category/scope/<scope>",
    GET_LEVELS: API_PATH + "/emission/calculator/level/db/<db>/scope/<scope>?category=<category>&level=<level>&level1=<level1>&level2=<level2>&level3=<level3>&level4=<level4>&level5=<level5>",
    GET_DB: API_PATH + "/emission/calculator/db",
    LINK_EMI_FACT_DP: API_PATH + "/emission/calculator/link?metricDataPointId=<metricDataPointId>",
    LINK_EMI_FACT_MET: API_PATH + "/emission/calculator/link?metricId=<metricId>",
    GET_EMI_FACT: API_PATH + "/emission/calculator/link?metricDataPointId=<metricDataPointId>",
    GET_SOURCES_BY_VERSION: GHG_EMISSION_PATH + "/emission/version-ref/<versionId>/distinct-names?db=<emissiontable>&scope=<scope>&category=<category>",
    GET_VERSION_SCOPE_DETAILS: GHG_EMISSION_PATH + "/emission/version-ref/<versionId>/scope-details?db=<db>",
  },
  GHG_EMISSION: {
    GET_TEMPLATE: GHG_EMISSION_PATH + "/purchased-items/template/excel/download",
    UPLOAD_TEMP: GHG_EMISSION_PATH + "/purchased-items/data/excel/import/company/<companyId>/standard/<standardId>/bu/<entityId>",
    GET_DATA_COLLECTION: GHG_EMISSION_PATH + "/purchased-items/data/company/<companyId>/standard/<standardId>/bu/<entityId>?pageNumber=<pageNumber>&pageSize=<pageSize>&status=<status>",
    GET_DB_INFO: GHG_EMISSION_PATH + "/emission/dbs",
    GET_FACTORS: GHG_EMISSION_PATH + "/emission/db/<db>/factors?pageNumber=<pageNumber>&pageSize=<pageSize>&key=<key>",
    SAVE_COL_DATA: GHG_EMISSION_PATH + "/purchased-items/data/db/<db>/company/<companyId>/standard/<standardId>/bu/<entityId>/save?finalize=<finalizeStatus>",
    FINALIZE_COL_DATA: GHG_EMISSION_PATH + "/purchased-items/data/company/<companyId>/standard/<standardId>/bu/<entityId>/finalize",
    CHECK_IMPORT: GHG_EMISSION_PATH + "/purchased-items/data/excel/import/status/company/<companyId>",
    EDIT_COL_ITEM: GHG_EMISSION_PATH + "/purchased-items/company/<companyId>/standard/<standardId>/save?db=<db>&businessUnitId=<entityId>&finalize=true",
    AI_MAP_CATEGORY: "/ai-emission/bulk-mapping/v0/<companyId>/<entityId>/<db>/<jobId>",
    AI_MAP_CATEGORY_STATUS: "/ai-emission/status/v0/<companyId>/<entityId>/<jobId>",
    AI_SELECTED_MAP_CATEGORY: "/ai-emission/mapping/v0/<companyId>/<entityId>/<db>/<jobId>",
    CREATE_JOB_ID: GHG_EMISSION_PATH + "/purchased-items/company/<companyId>/bu/<entityId>/cat/job",
    GET_ORG_BOUNDARIES: GHG_EMISSION_PATH + "/inventory/organizational/boundary/<companyId>/<period>",
    SAVE_ORG_BOUNDARIES: GHG_EMISSION_PATH + "/inventory/organizational/boundary/<period>/<companyId>",
    GET_SCOPES_DATA: GHG_EMISSION_PATH + "/inventory/scopes/details?period=<period>&companyId=<companyId>",
    SAVE_OPR_BOUNDARIES: GHG_EMISSION_PATH + "/inventory/operational/boundary/<period>/<companyId>",
    GET_DATA_SET: GHG_EMISSION_PATH + "/inventory/emission/dataset?companyId=<companyId>",
    GET_EMISSION_SOURCES: GHG_EMISSION_PATH + "/inventory/emission/source/<dataset>?period=<period>&companyId=<companyId>",
    SAVE_EMISSION_SOURCES: GHG_EMISSION_PATH + "/inventory/emission/source/<dataset>/<period>/<companyId>",
    GET_SUMMARY: GHG_EMISSION_PATH + "/inventory/emission/summary/<dataset>?period=<period>&companyId=<companyId>",
    GET_SUMMARY_ALL: GHG_EMISSION_PATH + "/inventory/emission/summary/all?period=<period>&companyId=<companyId>",
    FINALIZE_GHG_INV: GHG_EMISSION_PATH + "/inventory/emission/finalize?period=<period>&companyId=<companyId>",
    GET_SCOPES: GHG_EMISSION_PATH + "/inventory/scopes/details",
    GET_MAT_SCOPE_CAT: API_PATH + "/emission/metric/<standardId>/scopes",
    GET_EMISSION_SUMMARY: API_PATH + "/emission/summary/standard/<standardId>/<period>?scope=All",
    GET_BY_PERIOD: API_PATH + "/emission/period/standard/<standardId>/<period>?scope=All",
    GET_BY_GHG_TYPE: API_PATH + "/emission/ghg/standard/<standardId>/<period>?scope=All",
    ADD_METRIC_EMISSION_LINKING: API_PATH + '/emission/<standardId>/metric/<metricId>/linking', //29323
    GET_EMISSION_SOURCE: GHG_EMISSION_PATH + "/emission/distinct-names?db=<emissiontable>&scope=<scope>&category=<category>",//29323
    GET_METRIC_EMISSION_LINKING: API_PATH + '/emission/<standardId>/metric/<metricId>/linking', //29323
    ADD_DATAPOINT_EMISSION_LINKING: API_PATH + '/emission/<standardId>/datapoint/<datapointId>/linking', //29323
    GET_DATAPOINT_EMISSION_LINKING: API_PATH + '/emission/<standardId>/datapoint/<datapointId>/linking', //29323
    DELETE_METRIC_EMISSION_LINKING: API_PATH + '/emission/<standardId>/metric/<metricId>/unlinking', //29323
    DELETE_DATAPOINT_EMISSION_LINKING: API_PATH + '/emission/<standardId>/datapoint/<datapointId>/unlinking', //29323
    GET_DV_DATA: API_PATH + "/emission/source/grouped/v2/<standardId>?businessUnitIds=<businessUnitIds>&periodFrom=<periodFrom>&periodTo=<periodTo>&scope=<scope>&category=<category>"
  },
  CALENDAR_EVENT: {
    GET: API_PATH + "/calendar/event/<id>",
    UPDATE: API_PATH + "/calendar/event/<id>",
    ACTIVATE: API_PATH + "/calendar/company/<companyId>/event/<id>/activate/<active>",
    GET_EVENTS_RANGE: API_PATH + "/calendar/event/range?startDate=<startDate>&endDate=<endDate>",
  },
  AI_COPILOT_CONFIG: {
    GET_STYLES: API_PATH + "/copilot/config/styles",
    GET_TONES: API_PATH + "/copilot/config/tones",
    GET_SECTIONS: API_PATH + "/copilot/config/sections",
    GET_ACTIVE_CONFIG: API_PATH + "/copilot/config/active",
    UPDATE_WORD_COUNT: API_PATH + "/copilot/config/<id>/section/<sectionType>/wordcount/<countType>",
    UPDATE_STYLE: API_PATH + "/copilot/config/<id>/style/<type>",
    UPDATE_TONE: API_PATH + "/copilot/config/<id>/tone/<type>",
    APPLY_DEFAULT_CONFIG_FOR_COMPANY: API_PATH + "/admin/copilot/config/company/<companyId>/sync",
    GET_COPILOT_SET: API_PATH + "/copilot/config/params",
    GET_ALL_STYLE: API_PATH + "/copilot/config/params",
    SAVE_CONFIG: API_PATH + "/copilot/config/save",
    SAVE_PROMPTS: REPORT_AI_BASE_URL + "/copilot/save_prompts",
    LIST_PROMPTS: REPORT_AI_BASE_URL + "/copilot/list_prompts",
    GET_CATEGORIES_TOPICS: REPORT_AI_BASE_URL + "/copilot/categories_topics",
    GET_CATEGORIES_TOPICS_BY_FRAMEWORK: REPORT_AI_BASE_URL + "/copilot/categories_topics?framework=<framework>",
    GET_PROMPTS_BY_CATEGORY_TOPIC: REPORT_AI_BASE_URL + "/copilot/get_prompts?framework=<framework>&category=<category>&topic=<topic>",
    DELETE_PROMPT_BY_CATEGORY_TOPIC: REPORT_AI_BASE_URL + "/copilot/delete_prompt/<framework>/<category>/<topic>",
    GENERATE_PROMPT: REPORT_AI_BASE_URL + "/copilot/gri_prompt_generation",
    GET_COPILOT_HISTORY: REPORT_AI_BASE_URL + "/copilot/copilot_history?company_id=<companyId>&user_id=<userId>&report_name=<reportName>&report_page=<reportPage>&start_limit=<startLimit>&end_limit=<endLimit>",
    DELETE_COPILOT_HISTORY: REPORT_AI_BASE_URL + "/copilot/copilot_history?company_id=<companyId>&user_id=<userId>&report_name=<reportName>&report_page=<reportPage>"
  },
  NEW_USER: {
    GET_USER_LIST: "/users/list"
  },
  HOME_PAGE_CONFIG: {
    GET_DATA_COL_COUNT: FORM_BUILDER_PATH + "/dataCollectionCount?period=<period>",
    GET_DATA_COL_COUNT_PERIOD: FORM_BUILDER_PATH + "/dataCollectionCount?periodStart=<periodStart>&periodEnd=<periodEnd>",
    GET_REPORT_COUNT: API_PATH + "/report/statusCount?period=<period>&regulationId=<regulationId>",
    GET_PERF_HIGHLIGHTS: API_PATH + "/dynamic/graph/performanceHighlight/standard/<standardId>?category=<category>&period=<period>",
    GET_ESRS_REPORT_COUNT: "/esrs/dashboard/report/statusCount?period=<period>&periodStart=<periodStart>&periodEnd=<periodEnd>&regulationId=<regulationId>&frequencyType=<frequencyType>",
    GET_BRANCH_UNANSWERED_DPS: API_PATH + "/metric/dv/analytics/dps",
  },
  MATERIAL_ISSUES: {
    ADD_TOPIC: ESG_DATA_SERVICE_PATH + "/master/material/issue/upsert",
    GET_TOPIC: ESG_DATA_SERVICE_PATH + "/master/material/issue/parents?category=<category>&fullyLoad=<fullyLoad>&issueCategory=<issueCategory>&companyRef=<companyRef>",
    GET_SUB_TOPIC: ESG_DATA_SERVICE_PATH + "/master/material/issue/children/<id>?companyRef=<companyRef>",
    UPDATE_TOPIC: ESG_DATA_SERVICE_PATH + "/master/material/issue/upsert",
    DELETE_TOPIC: ESG_DATA_SERVICE_PATH + "/master/material/issue/<id>",
    SEARCH_TOPICS: ESG_DATA_SERVICE_PATH + "/master/material/issue/search?name=<name>",
    SAVE_FOR_COMPANY: MATERIALITY_SERVICE_PATH + "/materialIssueTopic/save?category=<category>",
    GET_ALL_FOR_COMPANY: MATERIALITY_SERVICE_PATH + "/materialIssueTopic/all/<period>/company/<companyId>?category=<category>&fullyLoad=<fullyLoad>",
    FINALIZE: MATERIALITY_SERVICE_PATH + "/mit/form/finalize/<companyId>/year/<year>",
    VERSIONS_LIST: MATERIALITY_SERVICE_PATH + "/materialIssueTopic/version/page/all/<year>/company/<companyId>",
    GET_VERSION_BASED: MATERIALITY_SERVICE_PATH + "/materialIssueTopic/all/<year>/version/<versionId>/company/<companyId>/?fullyLoad=true",
    SAVE_FOR_COMPANY_NEW: MATERIALITY_SERVICE_PATH + "/materialIssueTopic/save/version/<versionId>?category=<category>",
    FINALIZE_NEW: MATERIALITY_SERVICE_PATH + "/mit/form/v1/finalize/<companyId>/year/<year>/version/<versionId>?languageCode=<lang>&issueCategory=<issueCategory>",
    GET_COUNTS: MATERIALITY_SERVICE_PATH + "/materialIssueTopic/progress/<year>/version/<versionId>/company/<companyId>?fetchCloneInfo=<clonedInfoStatus>&issueCategory=<issueCategory>",
    GET_SEL_OMIT_DATA: MATERIALITY_SERVICE_PATH + "/materialIssueTopic/all/<year>/version/<versionId>/company/<companyId>?fullyLoad=true&selected=<status>&category=<category>&issueCategory=<issueCategory>",
    SAVE_SELECTED_TOPIC: MATERIALITY_SERVICE_PATH + "/materialIssueTopic/select/company/<companyId>/year/<year>/v/<versionId>?topicRefToSelect=<topicId>&issueCategory=<issueCategory>",
    SAVE_OMITTED_TOPIC: MATERIALITY_SERVICE_PATH + "/materialIssueTopic/omit/company/<companyId>/year/<year>/v/<versionId>?topicRefToOmit=<topicId>&topicMasterRef=<masterTopicId>&issueCategory=<issueCategory>",
    GET_NEW_DRAFT: MATERIALITY_SERVICE_PATH + "/materialIssueTopic/progress/<year>/version/<versionId>/company/<companyId>?category=<category>&status=<status>&issueCategory=<issueCategory>",
    UPDATE_MATERIALITY: MATERIALITY_SERVICE_PATH + "/materialIssueTopic/<id>?issueCategory=<issueCategory>",
    GET_LATEST_ISSUE_VERSION: MATERIALITY_SERVICE_PATH + "/materialIssueTopic/company/<companyId>/year/<year>/status/<status>/latest/version",
    GET_MATERIAL_ISSUES_CAT: ESG_DATA_SERVICE_PATH + "/master/material/issue/category",
    GET_STATS: MATERIALITY_SERVICE_PATH + "/stats/company/<companyId>/year/<year>?issueCategory=<issueCategory>"
  },
  STAKEHOLDER_LIBRARY: {
    UPSERT_STAKEHOLDER: ESG_DATA_SERVICE_PATH + "/master/stakeholder/upsert",
    GET_PARENT_STAKEHOLDERS: ESG_DATA_SERVICE_PATH + "/master/stakeholder/parents",
    GET_CHILD_STAKEHOLDERS: ESG_DATA_SERVICE_PATH + "/master/stakeholder/children/<id>",
    DELETE_STAKEHOLDER: ESG_DATA_SERVICE_PATH + "/master/stakeholder/<id>"
  },
  STAKEHOLDER_MAPPING: {
    GET_STAKEHOLDERS: MATERIALITY_SERVICE_PATH + "/stakeholder/all/<year>/company/<companyId>",
    GET_STAKEHOLDER_DETAILS: MATERIALITY_SERVICE_PATH + "/stakeholder/<id>",
    UPSERT_STAKEHOLDER: MATERIALITY_SERVICE_PATH + "/stakeholder/upsert/<year>/company/<companyId>",
    UPSERT_STAKEHOLDER_EMAILS: MATERIALITY_SERVICE_PATH + "/stakeholder/group/upsert/<id>/company/<companyId>",
    MAP_STAKEHOLDER: MATERIALITY_SERVICE_PATH + "/stakeholder/<year>/company/<companyId>/activate",
    GET_STAKEHOLDER_CHILDREN: MATERIALITY_SERVICE_PATH + "/stakeholder/all/children/<year>/company/<companyId>",
    UPDATE_STAKEHOLDER: MATERIALITY_SERVICE_PATH + "/stakeholder/<id>",
    DELETE_STAKEHOLDER: MATERIALITY_SERVICE_PATH + "/stakeholder/<id>",
    GET_ALL_PARENT_CHILD_STAKEHOLDERS: ESG_DATA_SERVICE_PATH + "/master/stakeholder/parents?fullyLoad=true",
    DELETE_STAKEHOLDER_GROUP: MATERIALITY_SERVICE_PATH + "/stakeholder/group/<id>",
    GET_STAKEHOLDER_DEFAULTVIEW: MATERIALITY_SERVICE_PATH + "/stakeholder/page/all/<year>/company/<companyId>?pageSize=<pageSize>&pageNumber=<pageNumber>&key=<key>",
    UPSERT_MULTIPLE_STAKEHOLDERS: MATERIALITY_SERVICE_PATH + "/stakeholder/upsert/data/company/<companyId>",
  },
  IMPLEMENTATION_GUIDE: {
    GET_STEPS: API_PATH + "/implguide/steps"
  },
  SCORE_CARD: {
    GET: MATERIALITY_SERVICE_PATH + "/stakeholder/scorecard/assessment/<assessmentId>/version/<version>",
    GET_DEFAULT: MATERIALITY_SERVICE_PATH + "/scorecard/active/company/<companyId>/year/<year>",
    GET_CONSOLIDATED: MATERIALITY_SERVICE_PATH + "/stakeholder/scorecard/info?companyId=<companyId>&assessmentId=<assessmentId>",
    SAVE_DATA: MATERIALITY_SERVICE_PATH + "/stakeholder/ranking/saveOrUpdate/assessment/<assessmentId>/version/<version>/company/<companyId>",
    FINALIZE_DATA: MATERIALITY_SERVICE_PATH + "/scorecard/company/<companyId>/assessment/<assessmentId>/version/<version>/finalize?graphImg=<graphImg>&company=<company>",
    GET_SCORE_FOR_QUESTION: MATERIALITY_SERVICE_PATH + "/scorecard/company/<companyId>/question/<questionId>/group/<groupId>",
    GET_SC_VERSIONS: MATERIALITY_SERVICE_PATH + "/scorecard/versions/company/<companyId>/year/<year>",
    GET_LATEST_REPORT: MATERIALITY_SERVICE_PATH + "/scorecard/versions/company/<companyId>/year/<year>",
    GENERATE_REPORT: MATERIALITY_SERVICE_PATH + "/scorecard/company/<companyId>/version/<version>/report?company=<compName>",
    GET_REPORT_LIST: "/report/all?pageSize=<pageSize>&pageNumber=<pageNumber>&companyId=<companyId>&type=DOUBLE_MATERIALITY&year=<year>",
  },
  MATERIALITY_ASSESSMENT: {
    LIST: MATERIALITY_SERVICE_PATH + "/mat/<regulationId>/list?pageNumber=<pageNumber>&sort=<sort>&pageSize=<pageSize>",
    GET_SURVEY_FORMS: FORM_BUILDER_PATH + "/forms/<companyId>",
    CREATE: FORM_BUILDER_PATH + '/assessments/materiality',
    UPDATE: FORM_BUILDER_PATH + '/assessments/materiality/<id>',
    GET: API_PATH + "/mat/<id>",
    SHARE: FORM_BUILDER_PATH + '/assessments/materiality/<id>/share',
    GET_SHARE_DETAILS: API_PATH + '/mat/<id>/share/details?pageNumber=<pageNumber>&pageSize=<pageSize>',
    GET_STAKEHOLDER_CHILDREN: FORM_BUILDER_PATH + "/materiality/stakeholders/children/<year>/company/<companyId>",
    GET_REPORT: "/report/<reportId>",
    GET_SHARED_GROUPS: FORM_BUILDER_PATH + "/assessments/materiality/<id>/shared-groups",
    RE_SHARE: FORM_BUILDER_PATH + "/assessments/materiality/<id>/re-share",
    GET_LATEST_REPORT: "/report/latest/<year>/type/DOUBLE_MATERIALITY",
  },
  ESRSREPORT: {
    CREATE_REPORT: "/report",
    UPDATE_REPORT: "/report/<reportId>",
    GET_REPORT: "/report/<reportId>",
    LIST_REPORTS: "/report/all?pageSize=<pageSize>&pageNumber=<pageNumber>&regulationId=<regulationId>&companyId=<companyId>&status=<status>&type=<type>&year=<year>&reportType=<reportType>",
    GENERATE_PDF: "/esrs/report/<reportId>/generate-pdf",
    GET_TEMPLATE: API_PATH + "/admin/report/studio/v2/template?page=<pageId>&type=<type>&standardId=<standardId>&period=<period>&answerCheck=<answerCheck>&periodEnd=<periodEnd>&buIds=<buIds>&rFreq=<rFreq>",
    FINALIZE: "/report/<id>/finalize",
    DELETE_REPORT: "/report/<id>",
    CREATE_JOB_UPDATE_REPORT: "/esrs/report/create-job-update",
    UPDATE_REPORT_CONTENT: "/esrs/report/update-content",
    FAILED: "/esrs/report/<id>/failed",
    CREATE_CODRAFT_JOB: "/report/<id>/codraft/job"
  },
  GHGREPORT: {
    CREATE_GHG_REPORT: "/ghg/report",
    UPDATE_GHG_REPORT: "/ghg/report/<reportId>",
    LIST_GHG_REPORTS: "/report/all?pageSize=<pageSize>&pageNumber=<pageNumber>&regulationId=<regulationId>&companyId=<companyId>&status=<status>&type=<type>&year=<year>&reportType=GHG",
    GET_REPORT: "/report/<reportId>"
  },
  BRSRREPORT: {
    CREATE_BRSR_REPORT: "/brsr/report",
    UPDATE_BRSR_REPORT: "/brsr/report/<reportId>",
    GET_REPORT: "/report/<reportId>",
    GET_TEMPLATE_BASIC: API_PATH + "/admin/report/studio/template/basic?page=<pageId>&type=<type>&standardId=<standardId>&periodStart=<periodStart>&periodEnd=<periodEnd>&rFreq=<rFreq>&offset=<offset>"
  },
  QUESTIONS_DATA: {
    GET_QUESTIONS: API_PATH + "/admin/report/studio/management/template?page=<page>&type=<type>",
    SAVE_QUESTIONS: API_PATH + "/admin/report/studio/management/template",
    DELETE_FULL_QUESTIONS: API_PATH + "/admin/report/studio/management/template?key=<type>",
    SAVE_QUESTIONS_POSITION: API_PATH + "/admin/report/studio/management/template/sort",
  },
  TEXT_TRANSLATOR: {
    GET_TRANSLATION: ''
  },
  LANGUAGE_SELECT: {
    GET_COMP_LANGUAGES: API_PATH + '/company/language'
  },
  LANGUAGE: {
    GET_LANGUAGES: ESG_DATA_SERVICE_PATH + "/master/language",
    GET_COMPANY_LANGUAGES: API_PATH + "/company/language"
  },
  VSME_REPORT: {
    CREATE_REPORT: "/report",
    UPDATE_REPORT: "/report/<reportId>",
    GET_REPORT: "/report/<reportId>",
    LIST_REPORTS: "/report/all?pageSize=<pageSize>&pageNumber=<pageNumber>&regulationId=<regulationId>&companyId=<companyId>&status=<status>&type=<type>&year=<year>&reportType=VSME",
    GENERATE_PDF: "/report/<reportId>/generate-pdf",
    GET_TEMPLATE: API_PATH + "/admin/report/studio/v2/template?page=<pageId>&type=<type>&standardId=<standardId>&period=<period>&answerCheck=<answerCheck>&periodEnd=<periodEnd>&buIds=<buIds>",
    FINALIZE: "/report/<id>/finalize",
    DELETE_REPORT: "/report/<id>",
    CREATE_JOB_UPDATE_REPORT: "/report/create-job-update",
    UPDATE_REPORT_CONTENT: "/report/update-content",
    FAILED: "/report/<id>/failed",
  },
  REPORT_DATA: {
    GET_ESG_SUMMARY: API_PATH + "/report/esg/summary/standard/<standardId>?periodStart=<periodStart>&periodEnd=<periodEnd>&buIds=<buIds>&topicIds=<topicIds>",
    GET_METRIC_INSIGHTS: API_PATH + "/admin/report/studio/metric/insights?type=<type>&standardId=<standardId>&period=<period>&periodEnd=<periodEnd>&rFreq=<rFreq>"
  },
  ANALYTICS: {
    GET_METRIC_DV: API_PATH + '/metric/dv/analytics',
    GET_METRIC_DV_GRAPH: API_PATH + '/metric/dv/analytics/graph',
    GET_DATAPOINT_DV: API_PATH + '/metric/dp/dv/analytics',
    GET_ANALYTICS_FILTERS: API_PATH + '/metric/dv/analytics/filters',
    SAVE_ANALYTICS_FILTER: API_PATH + '/metric/dv/analytics/filters',
    DELETE_ANALYTICS_FILTER: API_PATH + '/metric/dv/analytics/filters',
  },
  TRANSACTIONS: {
    GET_FORM_CREATION_STATUS: API_PATH + '/transactions/form-creation/status/<companyId>/<standardId>',
  },
  THIRD_PARTY_CLIENT: {
    GET_BY_COMPANY: API_PATH + "/admin/third-party/clients/company/<companyId>",
    GET: API_PATH + "/admin/third-party/clients/<clientId>",
    CREATE: API_PATH + "/admin/third-party/clients",
    UPDATE: API_PATH + "/admin/third-party/clients/<clientId>",
    DELETE: API_PATH + "/admin/third-party/clients/<clientId>",
  },
  GHG_EMISSION_MASTER_DATA: {
    // Datasets
    LIST_DATASETS: GHG_EMISSION_PATH + "/emission/datasets",
    GET_DATASET: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>",
    LIST_VERSIONS: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/versions",
    CREATE_VERSION: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/versions",
    UPDATE_VERSION: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/versions/<versionNumber>",
    CLONE_VERSION: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/versions/<sourceVersion>/clone",
    DELETE_VERSION: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/versions/<versionNumber>",
    EXPORT_VERSION: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/versions/<versionNumber>/export",
    IMPORT_VERSION: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/versions/<versionNumber>/import",
    // Emission Sources
    LIST_SOURCES: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/version/<version>/sources",
    GET_SOURCE: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/version/<version>/sources/<sourceId>",
    CREATE_SOURCE: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/version/<version>/sources",
    UPDATE_SOURCE: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/version/<version>/sources/<sourceId>",
    DELETE_SOURCE: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/version/<version>/sources/<sourceId>",
    // Emission Factors
    LIST_FACTORS: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/version/<version>/factors",
    GET_FACTOR: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/version/<version>/factors/<factorId>",
    GET_FACTORS_BY_SOURCE: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/version/<version>/factors/by-source/<sourceId>",
    CREATE_FACTOR: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/version/<version>/factors",
    UPDATE_FACTOR: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/version/<version>/factors/<factorId>",
    DELETE_FACTOR: GHG_EMISSION_PATH + "/emission/datasets/<datasetName>/version/<version>/factors/<factorId>",
  },
  UOM: {
    VERSIONS: {
      LIST: API_PATH + "/uom/versions",
      GET: API_PATH + "/uom/versions/<versionNumber>",
      CREATE: API_PATH + "/uom/versions",
      UPDATE: API_PATH + "/uom/versions/<versionNumber>",
      DELETE: API_PATH + "/uom/versions/<versionId>",
      CLONE: API_PATH + "/uom/versions/<sourceVersion>/clone",
      EXPORT: API_PATH + "/uom/versions/<versionNumber>/export",
      IMPORT: API_PATH + "/uom/versions/<versionNumber>/import"
    },
    TABLE: {
      GET_BY_VERSION: API_PATH + "/admin/uom/conversion/table/version/<versionNumber>/company/<companyId>",
      CREATE_CONVERSION: API_PATH + "/admin/uom/version/<versionNumber>/company/<companyId>",
      UPDATE_CONVERSION: API_PATH + "/admin/uom/<id>",
      DELETE_CONVERSION: API_PATH + "/admin/uom/<id>"
    }
  },
  HIERARCHY: {
    PLANS: KPI_SERVICE_PATH + "/plans",
    PLAN: KPI_SERVICE_PATH + "/plans/<planId>",
    PLAN_ACTIVATE: KPI_SERVICE_PATH + "/plans/<planId>/activate?ownerId=<ownerId>",
    PLAN_CLOSE: KPI_SERVICE_PATH + "/plans/<planId>/close?ownerId=<ownerId>",
    PLAN_CLONE: KPI_SERVICE_PATH + "/plans/<planId>/clone",
    PLAN_LEVELS: KPI_SERVICE_PATH + "/plans/<planId>/levels",
    PLAN_LEVEL_FIELDS: KPI_SERVICE_PATH + "/plans/<planId>/levels/<levelId>/fields",
    PLAN_MILESTONE_STEPS: KPI_SERVICE_PATH + "/plans/<planId>/milestone-steps",
    PLAN_STATUS_THRESHOLDS: KPI_SERVICE_PATH + "/plans/<planId>/status-thresholds",
    PLAN_TREE: KPI_SERVICE_PATH + "/plans/<planId>/tree",
    PLAN_NODES_LIST: KPI_SERVICE_PATH + "/plans/<planId>/nodes-list",
    PLAN_EXECUTIVE: KPI_SERVICE_PATH + "/plans/<planId>/dashboard/executive",
    PLAN_MY_TASKS_DASHBOARD: KPI_SERVICE_PATH + "/plans/<planId>/dashboard/my-tasks",
    PLAN_MY_TASKS: KPI_SERVICE_PATH + "/plans/<planId>/my-tasks",
    MY_ASSIGNMENT_ROOTS: KPI_SERVICE_PATH + "/hierarchy/my-assignment-roots",
    METADATA: KPI_SERVICE_PATH + "/hierarchy/metadata",
    SETTINGS: KPI_SERVICE_PATH + "/hierarchy/settings",
    ROOTS: KPI_SERVICE_PATH + "/hierarchy/roots",
    CHILDREN: KPI_SERVICE_PATH + "/hierarchy/<parentId>/children",
    NODES: KPI_SERVICE_PATH + "/hierarchy/nodes",
    NODE: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>",
    NODE_MOVE: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/move",
    NODE_CLOSE: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/close",
    NODE_REOPEN: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/reopen",
    NODE_CLOSE_REQUEST: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/close-request",
    NODE_REOPEN_REQUEST: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/reopen-request",
    NODE_START: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/start",
    SEARCH: KPI_SERVICE_PATH + "/hierarchy/search",
    NODE_ASSIGNMENTS: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/assignments",
    PRINCIPALS_USERS: KPI_SERVICE_PATH + "/hierarchy/principals/users",
    PRINCIPALS_GROUPS: KPI_SERVICE_PATH + "/hierarchy/principals/groups",
    APPROVALS: KPI_SERVICE_PATH + "/approvals",
    APPROVAL_DECIDE: KPI_SERVICE_PATH + "/approvals/<approvalId>/decide",
    APPROVAL_REVERT: KPI_SERVICE_PATH + "/approvals/<approvalId>/revert",
    BUDGET_SUMMARY: KPI_SERVICE_PATH + "/budget/summary",
    BUDGET_TOTALS: KPI_SERVICE_PATH + "/budget/totals",
    BUDGET_REALLOCATIONS: KPI_SERVICE_PATH + "/budget/reallocations",
    BUDGET_REALLOCATION_DECIDE: KPI_SERVICE_PATH + "/budget/reallocations/<reallocationId>/decide",
    BUDGET_REALLOCATION_HISTORY: KPI_SERVICE_PATH + "/budget/reallocations/history",
    BUDGET_REALLOCATION_REVERT: KPI_SERVICE_PATH + "/budget/reallocations/<reallocationId>/revert",
    IMPORT_TEMPLATE: KPI_SERVICE_PATH + "/import/template",
    IMPORT: KPI_SERVICE_PATH + "/import",
    IMPORT_JOB: KPI_SERVICE_PATH + "/import/jobs/<jobId>",
    REPORTS: KPI_SERVICE_PATH + "/reports",
    REPORT: KPI_SERVICE_PATH + "/reports/<reportId>",
    REPORT_GENERATE: KPI_SERVICE_PATH + "/reports/<reportId>/generate",
    REPORT_JOB: KPI_SERVICE_PATH + "/reports/jobs/<jobId>",
    AUDIT: KPI_SERVICE_PATH + "/audit",
    NOTIFICATIONS: KPI_SERVICE_PATH + "/notifications",
    NOTIFICATIONS_COUNT: KPI_SERVICE_PATH + "/notifications/count",
    NOTIFICATION_READ: KPI_SERVICE_PATH + "/notifications/<notificationId>/read",
    NOTIFICATIONS_READ_SCOPED: KPI_SERVICE_PATH + "/notifications/read",
    NOTIFICATIONS_READ_ALL: KPI_SERVICE_PATH + "/notifications/read-all",
    NODE_COMMENTS: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/comments",
    NODE_PROGRESS: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/progress",
    NODE_PROGRESS_SUBMISSIONS: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/progress/submissions",
    NODE_MEASURE_ACTUALS: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/measure-actuals",
    EVIDENCE_DOWNLOAD: KPI_SERVICE_PATH + "/hierarchy/evidence/<evidenceId>/download",
    // Shared-parent (multi-parent hierarchy) links — a node keeps one real "home" parent plus
    // optional additional-parent links; its real score counts toward every linked parent's rollup.
    NODE_ADDITIONAL_PARENTS: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/additional-parents",
    NODE_ADDITIONAL_PARENT: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/additional-parents/<parentNodeId>",
    NODE_ADDITIONAL_CHILDREN: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/additional-children",
    // Dedicated per-root-pillar branch stats - direct child count (EXTERNAL_DEPENDENCY excluded
    // server-side) and measurement node count across the whole subtree, in one call. Replaces
    // client-side getChildren/getDescendants over the full tree for PlanDetail's pillar cards.
    PLAN_ROOT_BRANCH_STATS: KPI_SERVICE_PATH + "/plans/<planId>/root-branch-stats",
    PLAN_SI_BUDGET_UTILISED: KPI_SERVICE_PATH + "/plans/<planId>/si-budget-utilised",
    // Framework Mapping - a tenant-managed master list of ESG framework tags (GRI, SASB, TCFD...)
    // that DELIVERY (SI) nodes can be tagged with. NODE_FRAMEWORKS is a full-replace sub-resource,
    // same shape as NODE_ADDITIONAL_PARENTS above.
    FRAMEWORKS: KPI_SERVICE_PATH + "/hierarchy/frameworks",
    FRAMEWORK: KPI_SERVICE_PATH + "/hierarchy/frameworks/<frameworkId>",
    NODE_FRAMEWORKS: KPI_SERVICE_PATH + "/hierarchy/nodes/<nodeId>/frameworks",
    ALERT_RULES: KPI_SERVICE_PATH + "/hierarchy/alert-rules",
    ALERT_RULE: KPI_SERVICE_PATH + "/hierarchy/alert-rules/<ruleId>",
    ALERT_RULE_HISTORY: KPI_SERVICE_PATH + "/hierarchy/alert-rules/history",
    ALERT_RULE_HISTORY_DETAIL: KPI_SERVICE_PATH + "/hierarchy/alert-rules/history/<historyId>",
    ALERT_RULE_HISTORY_MARK_DONE:
      KPI_SERVICE_PATH + "/hierarchy/alert-rules/history/<historyId>/mark-done",
    ALERT_RULE_HISTORY_MY_SUMMARY: KPI_SERVICE_PATH + "/hierarchy/alert-rules/history/my-summary",
    ALERT_RULE_HISTORY_TOP_RECIPIENTS:
      KPI_SERVICE_PATH + "/hierarchy/alert-rules/history/top-recipients"
  },
  ANOMALY: {
    LIST: API_PATH + "/anomalies",
    SINGLE: API_PATH + "/anomalies/<id>",
    SUMMARY: API_PATH + "/anomalies/summary",
    STATS: API_PATH + "/anomalies/stats",
    DISMISS: API_PATH + "/anomalies/dismiss",
    REVOKE: API_PATH + "/anomalies/<id>/revoke-suppression",
    FIX: API_PATH + "/anomalies/<id>/fix",
    TIMESERIES: API_PATH + "/anomalies/timeseries",
    EXPORT_PDF: API_PATH + "/anomalies/export/pdf",
    EXPORT_EXCEL: API_PATH + "/anomalies/export/excel",
    RULE_CONFIGS: API_PATH + "/anomalies/rule-configs",
    RULE_CONFIG_TOGGLE: API_PATH + "/anomalies/rule-configs/<ruleCode>/toggle",
    BRANCH_DRILLDOWN: API_PATH + "/anomalies/stats/branch-drilldown",
    DETECT: API_PATH + "/anomalies/detect",
    DETECT_STATUS: API_PATH + "/anomalies/detect/status/<id>",
    DETECT_BACKFILL: API_PATH + "/anomalies/detect/backfill",
  },
  EMAIL_AUDIT: {
    LIST: SHARED_PATH + "/email/audit?page=<pageNumber>&size=<pageSize>&sort=<sort>&companyId=<companyId>&key=<key>&emailType=<emailType>&status=<status>",
  },
};
export default API_ROUTES;
